<script>
/* eslint-disable object-curly-newline */
import { getComponent, isNullOrUndefined } from "@syncfusion/ej2-base";
import { ColumnDirective, ColumnsDirective } from "@syncfusion/ej2-vue-querybuilder/src/query-builder/columns.directive";
import moment from "moment";
import JsonViewer from 'vue-json-viewer';
import { defineAsyncComponent } from "@common/defineAsyncComponent";
// import { ColumnDirective, ColumnsDirective } from "@syncfusion/ej2-vue-querybuilder";
import { library } from "@common/library/library";
import { componentStore } from "@common/componentStore/componentStore";
import { configStore } from "@common/configStore";
import { uStore } from "@common/userStore";

const controlComponent = defineAsyncComponent(() => import('@common/control/control.vue'));

const logicEditorConfig = {
    cId: "logicEditor",
    cType: "logicEditor",
    cTitle: "Logic Editor",
    cTemplate: `<div :id="cId" class="logic-editor" @mouseleave="mouseleave">
                    <div class="sub-setting-logic" v-if="!showLogicOnly">
                        <div class="action-area">
                            <button class="show-items-btn" type="button" @click="expandItems()">
                                <span v-if="showItems" class="expander-toggle">
                                    <span class="sr-only">(hide)</span>
                                    <span class="e-icons e-collapse"></span>
                                </span>
                                <span v-if="!showItems" class="expander-toggle">
                                    <span class="sr-only">(show)</span>
                                    <span class="e-icons e-expand"></span>
                                </span>
                                <span class="logic-summary">
                                    Logic
                                </span>
                            </button>
                            <ejs-button isPrimary="true" type="button" :cssClass="'add-item-btn'" v-on:click="addItem()" :disabled="disabled">Add Logic</ejs-button>
                        </div>
                        <div v-if="showItems">
                            <ul class="sub-setting-logic-items">
                                <li v-if="logic && logic.length === 0">No Logic Rules.  Click "Add Rule" to add one.</li>
                                <li v-for="(option,index) in logic" :key="index">
                                    <div class="action-area">
                                        <button class="object-item-toggle" @click="toggleExpand(index)">
                                            <span v-if="expanded[index]" class="expander-toggle">
                                                <span class="sr-only">(hide)</span>
                                                <span class="e-icons e-collapse"></span>
                                            </span>
                                            <span v-if="!expanded[index]" class="expander-toggle">
                                                <span class="sr-only">(show)</span>
                                                <span class="e-icons e-expand"></span>
                                            </span>
                                            <span>
                                                {{ option.record + "." + option.prop }}
                                            </span>
                                        </button>
                                        <ejs-dropdownbutton v-if="enableItemActions" :disabled="disabled" :items="allowedActions" cssClass="e-caret-hide editor-item-action" v-on:select="itemSelect($event, index, logic)">
                                            <span class="e-icons e-menu"></span><span class="sr-only">More</span>
                                        </ejs-dropdownbutton>
                                    </div>
                                    <div v-if="expanded[index]" class="object-item-content">
                                        <div class="logic-settings-button-area">
                                            <button type="button" @click="setActiveSubMenu(index, 1)" :class="{'active-button':activeSubMenus[index] === 1}">Criteria</button>
                                            <button type="button" @click="setActiveSubMenu(index, 2)" :class="{'active-button':activeSubMenus[index] === 2}">Property</button>
                                            <button type="button" @click="setActiveSubMenu(index, 3)" :class="{'active-button':activeSubMenus[index] === 3}">Value</button>
                                            <button type="button" @click="setActiveSubMenu(index, 4)" :class="{'active-button':activeSubMenus[index] === 4}">Import/Export</button>
                                            <button type="button" class="help-button" @click="setActiveSubMenu(index, false)">help</button>
                                        </div>
                                        <div>
                                            <div class="path-fields" v-show="!activeSubMenus[index]">
                                                <p class="guide-title">Logic Editor</p>
                                                <p>The <strong>"Criteria to Match"</strong> is the record and field(s) you want check for matching criteria.</p>
                                                <p>The <strong>"Property to Change"</strong> is the record and property on that record you want to change.</p>
                                                <p>The <strong>"Value to Use"</strong> is what value you want the new value to be, and where it will come from.</p>
                                                <p><strong>"Import/Export"</strong> allows you to import and export criteria.</p>
                                            </div>
                                            <div class="path-fields" v-show="activeSubMenus[index] === 1">
                                                <control :name="'RECORD_FROM__'+index" :value="logic[index].criteriaRecord" @update:value="logic[index].criteriaRecord = $event" :items="recordTypesItems" :disabled="disabled"></control>
                                                <label-wrapper :label-settings="{id:'querybuilder'+index, label:'Criteria'}" :prop-control-id="'querybuilder'+index"></label-wrapper>
                                                <div v-if="columnsAdded">
                                                    <ejs-querybuilder
                                                        :ref="'querybuilder'+index"
                                                        :columns="columns"
                                                        :change="onChange"
                                                        :ruleChange="onChange"
                                                        :operatorChange="onChange"
                                                        :fieldChange="onChange"
                                                        :created="onChange"
                                                        :readonly="disabled"
                                                        :field-mode="fieldMode"
                                                        :field-model="queryBuilderFields"
                                                    ><div></div></ejs-querybuilder>
                                                </div>
                                            </div>
                                            <div class="path-fields" v-show="activeSubMenus[index] === 2">
                                                <control :name="'RESULT_TYPE__'+index" :value="logic[index].resultType" @update:value="logic[index].resultType = $event" :disabled="disabled"></control>
                                                <control :name="'RECORD__'+index" :value="logic[index].record" @update:value="logic[index].record = $event" :items="recordTypesItems" :disabled="disabled"></control>
                                                <control :name="'PROP__'+index" :value="logic[index].prop" @update:value="logic[index].prop = $event" :disabled="disabled"></control>
                                                <control name="SHOW_PATHS" :actionParams="index" :disabled="disabled"></control>
                                            </div>
                                            <div class="path-fields" v-show="activeSubMenus[index] === 3">
                                                <control :name="'VALUE_TYPE__'+index" :value="logic[index].valueType" @update:value="logic[index].valueType = $event" :items="valueTypeItems" :disabled="disabled"></control>
                                                <div v-show="logic[index].valueType !== 'criteria'">
                                                    <div v-show="logic[index].valueType === 'control'">
                                                        <control :name="'VALUE_CONTROL__'+index" :value="logic[index].valueControl" @update:value="logic[index].valueControl = $event" :disabled="disabled"></control>
                                                    </div>
                                                    <div v-show="logic[index].valueType === 'path'">
                                                        <control :name="'VALUE_PATH__'+index" :value="logic[index].valuePath" @update:value="logic[index].valuePath = $event" :disabled="disabled"></control>
                                                        <div class="e-card">
                                                            <control name="SHOW_PATHS" :actionParams="index" :disabled="disabled"></control>
                                                        </div>
                                                    </div>
                                                    <div v-show="logic[index].valueType === 'account'">
                                                        <control :name="'VALUE_ACCOUNT__'+index" :value="logic[index].valueAccountSetting" @update:value="logic[index].valueAccountSetting = $event" :disabled="disabled"></control>
                                                    </div>
                                                    <div v-show="logic[index].valueType === 'user'">
                                                        <control :name="'VALUE_USER_SETTING__'+index" :value="logic[index].valueUserSetting" @update:value="logic[index].valueUserSetting = $event" :disabled="disabled"></control>
                                                    </div>
                                                    <div v-show="logic[index].valueType === 'value'">
                                                        <control :name="'VALUE__'+index" :value="logic[index].value" @update:value="logic[index].value = $event" :disabled="disabled"></control>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="path-fields" v-show="activeSubMenus[index] === 4">
                                                <div class="query-preview">
                                                    <pre>{{queryPreview}}</pre>
                                                </div>
                                                <control name="IMPORT_LOGIC" :disabled="disabled"></control>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-else-if="!loading">
                        <div v-if="fieldsNotFound" class="fields-not-found-warning">{{ fieldsNotFoundWarning }}</div>
                        <div v-else>
                            <ejs-querybuilder
                                :ref="'querybuilder' + cId"
                                :readonly="disabled"
                                :field-mode="fieldMode"
                                :field-model="queryBuilderFields"
                                :change="onChange"
                                :ruleChange="onChange"
                                :operatorChange="onChange"
                                :fieldChange="onChange"
                                :created="onChange"
                            ><div></div></ejs-querybuilder>
                        </div>
                    </div>
                </div>`,
    controls: [
        {
            name: 'RECORD',
            type: 'dropdown',
            label: 'Record to Change',
            onchange: 'onChange',
            placeholder: 'Record Type',
            fields: { text: 'text', value: 'value' }
        },
        {
            name: 'RESULT_TYPE',
            type: 'dropdown',
            label: 'Result Type',
            onchange: 'onChange',
            placeholder: 'Record Type',
            items: [
                { text: 'Return Criteria Value', value: 'returnCriteria' },
                { text: 'Set Property', value: 'setProp' }
            ],
            fields: { text: 'text', value: 'value' }
        },
        {
            name: 'PROP',
            type: 'string',
            label: 'Property to Change',
            onchange: 'onChange',
            helpText: 'The path to the property you want to apply the resulting logic evaluation to. If you specify a value you want to apply, then the property will receive that value if the logic result is true.'
        },
        {
            name: 'RECORD_FROM',
            type: 'dropdown',
            label: 'Record to Check',
            onchange: 'onChange',
            placeholder: 'Record Type',
            fields: { text: 'text', value: 'value' }
        },
        {
            name: 'VALUE',
            type: 'string',
            label: 'Value to Apply',
            onchange: 'onChange',
            helpText: 'If the logic is true, take the value you specify here and apply it to your "Property to Change".'

        },
        {
            name: 'VALUE_PATH',
            type: 'string',
            label: 'Path of Value to Use',
            onchange: 'onChange',
            helpText: 'If the logic is true, take a value from another record property and apply it to your "Property to Change".'
        },
        {
            name: 'VALUE_ACCOUNT',
            type: 'dropdowntree',
            itemsSource: 'this.accountProperties',
            fields: {
                text: 'label',
                value: 'field',
                hasChildren: 'hasChild',
                parentValue: 'category'
            },
            label: 'Account Setting',
            onchange: 'onChange',
            helpText: 'If the logic is true, take a value from an account or user property and apply it to your "Property to Change".'
        },
        {
            name: 'VALUE_USER_SETTING',
            type: 'dropdowntree',
            itemsSource: 'this.userProperties',
            fields: {
                text: 'label',
                value: 'field',
                hasChildren: 'hasChild',
                parentValue: 'category'
            },
            label: 'User Property',
            onchange: 'onChange',
            helpText: 'If the logic is true, take a value from an account or user property and apply it to your "Property to Change".'
        },
        {
            name: 'VALUE_CONTROL',
            type: 'dropdown',
            label: 'Value From Control',
            onchange: 'onChange',
            placeholder: 'Get value from control',
            helpText: 'If the logic is true, take a value from a control and apply it to your "Property to Change".'
        },
        {
            name: 'SHOW_PATHS',
            type: 'button',
            label: 'Show Paths',
            onclick: 'showPaths'
        },
        {
            name: 'IMPORT_LOGIC',
            label: 'Import Rule',
            type: 'button',
            onclick: 'importLogic',
            cssClass: 'e-info'
        },
        {
            name: 'VALUE_TYPE',
            type: 'dropdown',
            label: 'Value Type',
            // onchange: 'changeValueType',
            onchange: 'onChange',
            fields: {
                text: 'text',
                value: 'value'
            },
            helpText: 'Choose the type of value to apply to your property after the logic is evaluated.  Note: "Result of Criteria Evaluation" option will always return true/false to your property.  Other values will not be applied if the logic evaluates as false.'
        },
    ],
    permissions: {
        delete: true,
        move: true,
        add: true
    }
};

const locals = {
    // returns a function for a dynamic vue component
    templateFunc(tmpCmp, templateId) {
        let func = function () {
            return {
                template: tmpCmp
            };
        };
        Object.defineProperty(func, "name", { value: templateId });
        return func;
    },
    fieldChangeAddInfo(_this, value) {
        if (
            !value
            && _this.$refs
            && _this.$refs['ruleField']
            && typeof _this.$refs['ruleField'].getData === "function"
            && _this.$refs['ruleField'].ej2Instances
            && Array.isArray(_this.$refs['ruleField'].ej2Instances.value)
            && _this.$refs['ruleField'].ej2Instances.value[0]
        ) {
            value = _this.$refs['ruleField'].ej2Instances.value[0];
        }
        if (value) {
            let tmpFieldData = _this.$refs['ruleField'].getData(value);
            if (Array.isArray(tmpFieldData) && tmpFieldData[0] && tmpFieldData[0].category && _this.dataRule.field === _this.data.rule.field) {
                let tmpPsp = tmpFieldData[0].category;
                _this.data.rule.psp = tmpPsp;
            }
        }
    },
    getRecordTypesItems(recordTypesItems) {
        return [{ text: 'Dynamically base on passed recordId to the component or contextId', value: 'dynamically' }].concat(recordTypesItems);
    },
    getRuleCollection(rule, isValidRule) {
        if (isNullOrUndefined(rule)) {
            return null;
        }
        let orgRule;
        if (rule.rules && rule.rules.length && (Object.keys(rule.rules[0]).length > 6 || isValidRule)) {
            let jLen = rule.rules.length;
            for (let j = 0; j < jLen; j++) {
                orgRule = rule.rules[j];
                orgRule = locals.getRuleCollection(orgRule, isValidRule);
                rule.rules[j] = orgRule;
                if (Object.keys(orgRule).length < 1 && isValidRule) {
                    rule.rules.splice(j, 1);
                    j--;
                    jLen--;
                }
            }
        }
        let customObj = rule.custom;
        if ((rule.field && rule.field !== '') && (isNullOrUndefined(customObj) || (customObj && (customObj.type !== 'question'
            && customObj.type !== 'answer')))) {
            if (rule.operator) {
                if (rule.operator.toString().indexOf('null') > -1 || rule.operator.toString().indexOf('empty') > -1) {
                    rule.value = null;
                }
            }
            if ((this.isRefreshed && this.enablePersistence) || (rule.field !== '' && rule.operator !== ''
                && (this.isValueEmpty ? rule.value !== '' && rule.value !== undefined : rule.value !== undefined))
                || (customObj && customObj.isQuestion)) {
                let condition = rule.condition;
                let lockedRule = rule.isLocked;
                rule = {
                    'label': rule.label,
                    'field': rule.field,
                    'operator': rule.operator,
                    'type': rule.type,
                    'value': rule.value,
                    'criteriaRecord': rule.criteriaRecord,
                    'additionalParam': rule.additionalParam,
                    'psp': rule.psp,
                };
                if (!isNullOrUndefined(lockedRule)) {
                    rule.isLocked = lockedRule;
                }
                if (condition) {
                    rule.condition = condition;
                }
                if (customObj) {
                    rule.custom = customObj;
                }
                if ((rule.operator === 'in' || rule.operator === 'notin') && rule.value && rule.value.length === 0) {
                    rule = {};
                }
            }
            else {
                rule = {};
            }
        }
        else {
            if (customObj && (customObj.type === 'question' || customObj.type === 'answer')) {
                let notValue = rule.not;
                rule = { 'label': rule.label,
                    'field': rule.field,
                    'operator': rule.operator,
                    'type': rule.type,
                    'value': rule.value,
                    'condition': rule.condition,
                    'rules': rule.rules,
                    'criteriaRecord': rule.criteriaRecord,
                    'additionalParam': rule.additionalParam,
                    'psp': rule.psp,
                };
                rule.custom = customObj;
                if (this.enableNotCondition) {
                    rule.not = notValue;
                }
            }
            else if ((isNullOrUndefined(rule.condition)) && isNullOrUndefined(rule.rules)) {
                rule = {};
            }
            else {
                let isLocked = rule.isLocked;
                if (this.enableNotCondition) {
                    rule = { 'condition': rule.condition, 'rules': rule.rules, 'not': rule.not };
                }
                else {
                    rule = { 'condition': rule.condition, 'rules': rule.rules };
                }
                if (!isNullOrUndefined(isLocked)) {
                    rule.isLocked = isLocked;
                }
                if (customObj) {
                    rule.custom = customObj;
                }
                if (rule.rules && rule.rules.length === 0) {
                    rule = {};
                }
            }
        }
        return rule;
    },
    queryBuilderPropChange(args, ruleId, type) {
        // Type is: value, operator or field
        let queryBuilderIDParts = ruleId.split('_');
        let value = args.value;
        if (!args.element || !document.body.contains(args.element)) return;
        if (type === 'field' && Array.isArray(value)) value = value[0];
        if (queryBuilderIDParts.length) {
            let queryBuilderID = queryBuilderIDParts[0] + '_' + queryBuilderIDParts[1];
            let queryBuilderObj = getComponent(document.getElementById(queryBuilderID), 'query-builder');
            if (queryBuilderObj) {
                switch (type) {
                    case 'changeField':
                        queryBuilderObj.changeField(args);
                        break;
                    default:
                        queryBuilderObj.notifyChange(value, args.element, type);
                        if (type === 'additionalParam') {
                            queryBuilderObj.trigger('change', {});
                        }
                        break;
                }
                /* if (type === 'changeField') {
                    queryBuilderObj.changeField(args);
                }
                queryBuilderObj.notifyChange(value, args.element, type);
                if (type === 'additionalParam') {
                    queryBuilderObj.trigger('change', {});
                } */
            }
        }
    },
    getColumnTypes(columnTypes, iThis) {
        if (!Array.isArray(columnTypes) || !columnTypes.length) return [];
        if (iThis.columns && iThis.columns.length) {
            return iThis.columns.filter((column) => (columnTypes.indexOf(column.field) > -1 || columnTypes.indexOf(column.category) > -1));
        }
        return [];
    },
    getFieldOperators(_this) {
        let operators = [];
        if (Array.isArray(_this.ruleField) && _this.ruleField.length) {
            let tmpField = _this.data.columns.find((tmpI) => tmpI['field'] === _this.ruleField[0]);
            if (tmpField && Array.isArray(tmpField.filterOperators) && tmpField.filterOperators.length) {
                let tmpOperators = [];
                for (let i in tmpField.filterOperators) {
                    let tmpOperand = _this.data.operators.find((tmp) => parseInt(tmp.operandID, 10) === parseInt(tmpField.filterOperators[i], 10));
                    if (!library.objIsEmpty(tmpOperand)) {
                        tmpOperators.push(tmpOperand);
                    }
                }
                operators = library.cloneObj(tmpOperators);
            } else {
                operators = _this.data.operators;
            }
        } else {
            operators = _this.data.operators;
        }
        return operators;
    },
    templateCreated(_this /* template component */, __this /* logicEditor component */) {
        if (
            _this.isAdditionalParamShown
            && !_this.data.rule.additionalParam
            && typeof _this?.parent?.additionalParamItems?.[_this.isAdditionalParamShown] !== 'undefined'
            && Array.isArray(_this.parent.additionalParamItems[_this.isAdditionalParamShown])
        ) {
            let selectedByDefault = _this.parent.additionalParamItems[_this.isAdditionalParamShown].find((tmp) => tmp.default);
            if (selectedByDefault) _this.data.rule.additionalParam = selectedByDefault.value;
        }
        if (!_this.data.rule.operator) {
            let defaultOperator = 'equal';
            if (
                Array.isArray(_this.operators)
                && _this.operators.length
                && _this.operators.findIndex((tmp) => tmp.vueValue === 'equal') === -1
                && _this.operators[0].vueValue
            ) {
                defaultOperator = _this.operators[0].vueValue;
            }
            _this.data.rule.operator = defaultOperator;
        }
        _this.$options.rule = library.cloneObj(_this.data.rule, true, true);
        _this.$options.fields = {
            dataSource: __this.columns,
            text: 'label',
            value: 'field',
            hasChildren: 'hasChild',
            parentValue: 'category'
        };
    }
};

const criteriaTemplates = {
    datePeriodTypeTemplateComponent: {},
    datePeriodTypeTemplate(_this) {
        if (this.datePeriodTypeTemplateComponent[_this.cId]) return this.datePeriodTypeTemplateComponent[_this.cId];
        let templateId = 'datePeriodTypeTemplate_' + _this.cId + '_' + library.getUniqueID();
        let tmpCmp = vueApp.component(templateId, {
            template: `<div class="e-rule e-rule-template date-type-template">
                        <div class="e-rule-filter e-custom-filter">
                            <ejs-dropdowntree :created="ddCreated" :showClearButton="false" :allowFiltering="true" :filterType="'Contains'" :ref="'ruleField'" :changeOnBlur="false" @select='fieldChange'>
                            </ejs-dropdowntree>
                            <div v-show="isAdditionalParamShown">
                                <ejs-dropdownlist
                                    :placeholder="parent.additionalParamPlaceholders[isAdditionalParamShown]"
                                    :fields="{ text: 'text', value: 'value' }"
                                    v-model="ruleAdditionalParam"
                                    @change='additionalParamChange'
                                    :dataSource="parent.additionalParamItems[isAdditionalParamShown]">
                                </ejs-dropdownlist>
                            </div>
                            <div v-show="!parent.showLogicOnly">
                                <ejs-dropdownlist :placeholder="'Record Type'" :fields="{ text: 'text', value: 'value' }" v-model="ruleCriteriaRecord" @change='recordTypeChange' :dataSource="recordTypesItems"></ejs-dropdownlist>
                            </div>
                        </div>
                        <div class="e-rule-operator e-operator">
                            <ejs-dropdownlist :change='operatorChange' :dataSource="operators" :fields='operatorFields' v-model='ruleOperator'>
                            </ejs-dropdownlist>
                        </div>
                        <div class="e-rule-value e-value" v-if="showInput">
                            <ejs-textbox :ref="'ruleValue'" v-model="ruleValue" :change="optionChange" :blur="validate"></ejs-textbox>
                        </div>
                        <div class="e-rule-btn e-rule-value-delete">
                            <button class="e-removerule e-rule-delete e-css e-btn e-small e-round">
                                <span class="e-btn-icon e-icons e-delete-icon"/>
                            </button>
                        </div>
                        <div class="clearfix"></div>
                    </div>`,
            data() {
                return {
                    data: {},
                    outputValue: '',
                    operatorFields: {
                        text: 'display',
                        value: 'vueValue'
                    },
                    parent: _this,
                    recordTypesItems: locals.getRecordTypesItems(_this.recordTypesItems),
                    refreshKey: 0
                };
            },
            created() {
                locals.templateCreated(this, _this);
            },
            computed: {
                dataRule() {
                    return library.cloneObj(this.data.rule, true, true);
                },
                operators() {
                    return locals.getFieldOperators(this);
                },
                isAdditionalParamShown() {
                    let isAdditionalParamShown = false;
                    if (Array.isArray(this.ruleField) && this.ruleField.length) {
                        let tmpField = this.data.columns.find((tmpI) => tmpI['field'] === this.ruleField[0]);
                        isAdditionalParamShown = tmpField?.category === 'org' || tmpField?.category === 'aff' ? tmpField?.category : false;
                        if (!this.parent?.additionalParamItems?.[isAdditionalParamShown]?.length) isAdditionalParamShown = false;
                    }
                    return isAdditionalParamShown;
                },
                ruleAdditionalParam() {
                    return this.dataRule.additionalParam;
                },
                showInput() {
                    let tmpOperator = this.operators.find((tmpI) => tmpI['vueValue'] === this.ruleOperator);
                    return tmpOperator && tmpOperator.input ? tmpOperator.input : false;
                },
                /* fields() {
                    return {
                        dataSource: _this.columns,
                        text: 'label',
                        value: 'field',
                        hasChildren: 'hasChild',
                        parentValue: 'category'
                    };
                }, */
                ruleValue() {
                    // do not remove refreshKey!!!
                    let refreshKey = this.refreshKey;
                    let tmpMonth = 0;
                    let tmpYears = 0;
                    let ruleValue = '';
                    if (parseInt(this.dataRule.value, 10) > 0) {
                        // eslint-disable-next-line no-bitwise
                        tmpYears = ~~(this.dataRule.value / 12);
                        tmpMonth = this.dataRule.value - (tmpYears * 12);
                    }
                    if (tmpYears) ruleValue += tmpYears + 'y';
                    if (tmpMonth) ruleValue += (tmpYears ? ' ' : '') + tmpMonth + 'm';
                    return ruleValue;
                },
                ruleField() {
                    if (Array.isArray(this.dataRule.field)) return this.dataRule.field;
                    return [this.dataRule.field];
                },
                ruleOperator() {
                    return this.dataRule.operator;
                },
                ruleCriteriaRecord() {
                    return this.dataRule.criteriaRecord;
                },
                ddOptions() {
                    let currentColumn;
                    if (this.dataRule && this.dataRule.field) {
                        currentColumn = this.data.columns.find((column) => column.field === this.dataRule.field);
                    }
                    if (currentColumn && currentColumn.options) return currentColumn.options;
                    return [];
                }
            },
            methods: {
                ddCreated() {
                    this.$refs['ruleField'].setProperties({ fields: this.$options.fields });
                    this.$refs['ruleField'].setProperties({ value: this.ruleField });
                },
                additionalParamChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    // this.data.rule.additionalParam = args.value;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'additionalParam');
                },
                validate: function (args) {
                    let val = args.value;
                    if (typeof val === 'string' && !val.trim()) {
                        library.showDialog('Can not add empty value', () => {
                            setTimeout(() => { args.event.target.focus(); }, 500);
                        }, false, { showAsAlert: true });
                        return false;
                    }
                    let patt1 = /^\d{1,2}[yY] \d{1,2}[mM]$/;
                    let patt2 = /^\d{1,2}[mM]$/;
                    let patt3 = /^\d{1,2}[yY]$/;
                    let patt4 = /^\d{1,2}$/;
                    if (!patt1.test(val) && !patt2.test(val) && !patt3.test(val) && !patt4.test(val)) {
                        library.showDialog(args.value + ' is not valid date period', () => {
                            setTimeout(() => { args.event.target.focus(); }, 500);
                        }, false, { showAsAlert: true });
                        return false;
                    }
                    return true;
                },
                fieldChange: function (args) {
                    if (!args?.isInteracted) return;
                    args.element = this.$refs['ruleField'].$el;
                    args.value = args.itemData.id;
                    locals.fieldChangeAddInfo(this, args.itemData.id);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'field');
                },
                recordTypeChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    this.data.rule.criteriaRecord = args.value;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'criteriaRecord');
                },
                operatorChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'operator');
                },
                optionChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    if (!args.value) args.value = args.checked;
                    let val = args.value;

                    let patt1 = /^\d{1,2}[yY] \d{1,2}[mM]$/;
                    let patt2 = /^\d{1,2}[mM]$/;
                    let patt3 = /^\d{1,2}[yY]$/;
                    let patt4 = /^\d{1,2}$/;
                    if (!patt1.test(val) && !patt2.test(val) && !patt3.test(val) && !patt4.test(val)) {
                        return;
                    }

                    let vM = val.match(/\d{1,2}[mM]/);
                    let vY = patt4.test(val) ? val.match(/^\d{1,2}$/) : val.match(/\d{1,2}[yY]/);
                    val = 0;
                    if (vM && vM.length) val += parseInt(vM[0], 10);
                    if (vY && vY.length) val += parseInt(vY[0], 10) * 12;
                    val = val.toString();
                    args.value = val;
                    let elemId = 'ruleValue_' + this.data.ruleID;
                    if (!args.element) args.element = args.container || false;
                    if (!args.element) args.element = this.$refs['ruleValue'].$el;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'value');
                    this.refreshKey++;
                }
            },
            components: {
                'ejs-dropdownlist': defineAsyncComponent(() => import('@common/syncfusion/dropdownList')),
                'ejs-dropdowntree': defineAsyncComponent(() => import('@common/syncfusion/dropdownTree')),
                'ejs-textbox': defineAsyncComponent(() => import('@common/syncfusion/text')),
            }
        });
        let tmpFunc = locals.templateFunc(tmpCmp, templateId);
        this.datePeriodTypeTemplateComponent[_this.cId] = tmpFunc;
        return tmpFunc;
    },
    stringTypeTemplateComponent: {},
    stringTypeTemplate(_this) {
        if (this.stringTypeTemplateComponent[_this.cId]) return this.stringTypeTemplateComponent[_this.cId];
        let templateId = 'stringTypeTemplate_' + _this.cId + '_' + library.getUniqueID();
        let tmpCmp = vueApp.component(templateId, {
            template: `<div class="e-rule e-rule-template string-type-template">
                        <div class="e-rule-filter e-custom-filter">
                            <ejs-dropdowntree :created="ddCreated" :showClearButton="false" :allowFiltering="true" :filterType="'Contains'" :ref="'ruleField'" :changeOnBlur="false" @select='fieldChange'>
                            </ejs-dropdowntree>
                            <div v-show="isAdditionalParamShown">
                                <ejs-dropdownlist
                                    :placeholder="parent.additionalParamPlaceholders[isAdditionalParamShown]"
                                    :fields="{ text: 'text', value: 'value' }"
                                    v-model="ruleAdditionalParam"
                                    @change='additionalParamChange'
                                    :dataSource="parent.additionalParamItems[isAdditionalParamShown]">
                                </ejs-dropdownlist>
                            </div>
                            <div v-show="!parent.showLogicOnly">
                                <ejs-dropdownlist :placeholder="'Record Type'" :fields="{ text: 'text', value: 'value' }" v-model="ruleCriteriaRecord" @change='recordTypeChange' :dataSource="recordTypesItems"></ejs-dropdownlist>
                            </div>
                        </div>
                        <div class="e-rule-operator e-operator">
                            <ejs-dropdownlist :change='operatorChange' :dataSource="operators" :fields='operatorFields' v-model='ruleOperator'>
                            </ejs-dropdownlist>
                        </div>
                        <div class="e-rule-value e-value" v-if="showInput">
                            <div v-if="showWithMask">
                                <ejs-maskedtextbox :ref="'ruleValue'" :mask="showWithMask" v-model="ruleValue" :change="optionChange" :input="optionChangeTimeoutFn"></ejs-maskedtextbox>
                            </div>
                            <div v-else>
                                <ejs-textbox :ref="'ruleValue'" v-model="ruleValue" :change="optionChange" :input="optionChangeTimeoutFn"></ejs-textbox>
                            </div>
                        </div>
                        <div class="e-rule-btn e-rule-value-delete">
                            <button class="e-removerule e-rule-delete e-css e-btn e-small e-round">
                                <span class="e-btn-icon e-icons e-delete-icon"/>
                            </button>
                        </div>
                        <div class="clearfix"></div>
                    </div>`,
            data() {
                return {
                    data: {},
                    outputValue: '',
                    operatorFields: {
                        text: 'display',
                        value: 'vueValue'
                    },
                    parent: _this,
                    recordTypesItems: locals.getRecordTypesItems(_this.recordTypesItems),
                    optionChangeTimeout: false
                };
            },
            created() {
                locals.templateCreated(this, _this);
            },
            computed: {
                dataRule() {
                    return library.cloneObj(this.data.rule, true, true);
                },
                operators() {
                    return locals.getFieldOperators(this);
                },
                isAdditionalParamShown() {
                    let isAdditionalParamShown = false;
                    if (Array.isArray(this.ruleField) && this.ruleField.length) {
                        let tmpField = this.data.columns.find((tmpI) => tmpI['field'] === this.ruleField[0]);
                        isAdditionalParamShown = tmpField?.category === 'org' || tmpField?.category === 'aff' ? tmpField?.category : false;
                        if (!this.parent?.additionalParamItems?.[isAdditionalParamShown]?.length) isAdditionalParamShown = false;
                    }
                    return isAdditionalParamShown;
                },
                ruleAdditionalParam() {
                    return this.dataRule.additionalParam;
                },
                showWithMask() {
                    let showWithMask = false;
                    if (Array.isArray(this.ruleField) && this.ruleField.length) {
                        let tmpField = this.data.columns.find((tmpI) => tmpI['field'] === this.ruleField[0]);
                        showWithMask = tmpField.mask || false;
                    }
                    if (this.ruleOperator !== "equal" && this.ruleOperator !== "notequal") {
                        showWithMask = false;
                    }
                    return showWithMask;
                },
                isEmail() {
                    let isEmail = false;
                    if (Array.isArray(this.ruleField) && this.ruleField.length) {
                        let tmpField = this.data.columns.find((tmpI) => tmpI['field'] === this.ruleField[0]);
                        isEmail = tmpField.IS_EMAIL || false;
                    }
                    if (this.ruleOperator !== "equal" && this.ruleOperator !== "notequal") {
                        isEmail = false;
                    }
                    return isEmail;
                },
                showInput() {
                    let tmpOperator = this.operators.find((tmpI) => tmpI['vueValue'] === this.ruleOperator);
                    return tmpOperator && tmpOperator.input ? tmpOperator.input : false;
                },
                /* fields() {
                    return {
                        dataSource: _this.columns,
                        text: 'label',
                        value: 'field',
                        hasChildren: 'hasChild',
                        parentValue: 'category'
                    };
                }, */
                ruleValue() {
                    return this.dataRule.value;
                },
                ruleField() {
                    if (Array.isArray(this.dataRule.field)) return this.dataRule.field;
                    return [this.dataRule.field];
                },
                ruleOperator() {
                    return this.dataRule.operator;
                },
                ruleCriteriaRecord() {
                    return this.dataRule.criteriaRecord;
                },
                ddOptions() {
                    let currentColumn;
                    if (this.dataRule && this.dataRule.field) {
                        currentColumn = this.data.columns.find((column) => column.field === this.dataRule.field);
                    }
                    if (currentColumn && currentColumn.options) return currentColumn.options;
                    return [];
                }
            },
            methods: {
                ddCreated() {
                    this.$refs['ruleField'].setProperties({ fields: this.$options.fields });
                    this.$refs['ruleField'].setProperties({ value: this.ruleField });
                },
                additionalParamChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    // this.data.rule.additionalParam = args.value;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'additionalParam');
                },
                fieldChange: function (args) {
                    if (!args?.isInteracted) return;
                    args.element = this.$refs['ruleField'].$el;
                    args.value = args.itemData.id;
                    locals.fieldChangeAddInfo(this, args.itemData.id);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'field');
                },
                recordTypeChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    this.data.rule.criteriaRecord = args.value;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'criteriaRecord');
                },
                operatorChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'operator');
                },
                validate: function (args) {
                    /* if (this.isEmail && this.showInput && !library.checkEmail(args.value)) {
                        library.showDialog(args.value + ' is not valid Email address', () => {
                            setTimeout(() => { args.event.target.focus(); }, 500);
                        }, false, { showAsAlert: true });
                        return false;
                    } */
                    return true;
                },
                optionChangeTimeoutFn(args) {
                    if (this.optionChangeTimeout) clearTimeout(this.optionChangeTimeout);
                    this.optionChangeTimeout = setTimeout(() => {
                        this.optionChange(args);
                    }, 1000);
                },
                optionChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    if (!this.validate(args)) return;
                    if (!args.value) args.value = args.checked;
                    let elemId = 'ruleValue_' + this.data.ruleID;
                    if (!args.element) args.element = args.container || false;
                    if (!args.element) args.element = this.$refs['ruleValue'].$el;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'value');
                }
            },
            components: {
                'ejs-dropdownlist': defineAsyncComponent(() => import('@common/syncfusion/dropdownList')),
                'ejs-dropdowntree': defineAsyncComponent(() => import('@common/syncfusion/dropdownTree')),
                'ejs-textbox': defineAsyncComponent(() => import('@common/syncfusion/text')),
                'ejs-maskedtextbox': defineAsyncComponent(() => import('@common/syncfusion/maskedText')),
            }
        });
        let tmpFunc = locals.templateFunc(tmpCmp, templateId);
        this.stringTypeTemplateComponent[_this.cId] = tmpFunc;
        return tmpFunc;
    },
    textTypeTemplateComponent: {},
    textTypeTemplate(_this) {
        if (this.textTypeTemplateComponent[_this.cId]) return this.textTypeTemplateComponent[_this.cId];
        let templateId = 'textTypeTemplate_' + _this.cId + '_' + library.getUniqueID();
        let tmpCmp = vueApp.component(templateId, {
            template: `<div class="e-rule e-rule-template text-type-template">
                        <div class="e-rule-filter e-custom-filter">
                            <ejs-dropdowntree :created="ddCreated" :showClearButton="false" :allowFiltering="true" :filterType="'Contains'" :ref="'ruleField'" :changeOnBlur="false" @select='fieldChange'>
                            </ejs-dropdowntree>
                            <div v-show="isAdditionalParamShown">
                                <ejs-dropdownlist
                                    :placeholder="parent.additionalParamPlaceholders[isAdditionalParamShown]"
                                    :fields="{ text: 'text', value: 'value' }"
                                    v-model="ruleAdditionalParam"
                                    @change='additionalParamChange'
                                    :dataSource="parent.additionalParamItems[isAdditionalParamShown]">
                                </ejs-dropdownlist>
                            </div>
                            <div v-show="!parent.showLogicOnly">
                                <ejs-dropdownlist :placeholder="'Record Type'" :fields="{ text: 'text', value: 'value' }" v-model="ruleCriteriaRecord" @change='recordTypeChange' :dataSource="recordTypesItems"></ejs-dropdownlist>
                            </div>
                        </div>
                        <div class="e-rule-operator e-operator">
                            <ejs-dropdownlist :change='operatorChange' :dataSource="operators" :fields='operatorFields' v-model='ruleOperator'>
                            </ejs-dropdownlist>
                        </div>
                        <div class="e-rule-value e-value" v-if="showInput">
                            <ejs-textbox :ref="'ruleValue'" v-model="ruleValue" :change="optionChange"></ejs-textbox>
                        </div>
                        <div class="e-rule-btn e-rule-value-delete">
                            <button class="e-removerule e-rule-delete e-css e-btn e-small e-round">
                                <span class="e-btn-icon e-icons e-delete-icon"/>
                            </button>
                        </div>
                        <div class="clearfix"></div>
                    </div>`,
            data() {
                return {
                    data: {},
                    outputValue: '',
                    operatorFields: {
                        text: 'display',
                        value: 'vueValue'
                    },
                    parent: _this,
                    recordTypesItems: locals.getRecordTypesItems(_this.recordTypesItems)
                };
            },
            created() {
                locals.templateCreated(this, _this);
            },
            computed: {
                dataRule() {
                    return library.cloneObj(this.data.rule, true, true);
                },
                operators() {
                    return locals.getFieldOperators(this);
                },
                isAdditionalParamShown() {
                    let isAdditionalParamShown = false;
                    if (Array.isArray(this.ruleField) && this.ruleField.length) {
                        let tmpField = this.data.columns.find((tmpI) => tmpI['field'] === this.ruleField[0]);
                        isAdditionalParamShown = tmpField?.category === 'org' || tmpField?.category === 'aff' ? tmpField?.category : false;
                        if (!this.parent?.additionalParamItems?.[isAdditionalParamShown]?.length) isAdditionalParamShown = false;
                    }
                    return isAdditionalParamShown;
                },
                ruleAdditionalParam() {
                    return this.dataRule.additionalParam;
                },
                showInput() {
                    let tmpOperator = this.operators.find((tmpI) => tmpI['vueValue'] === this.ruleOperator);
                    return tmpOperator && tmpOperator.input ? tmpOperator.input : false;
                },
                /* fields() {
                    return {
                        dataSource: _this.columns,
                        text: 'label',
                        value: 'field',
                        hasChildren: 'hasChild',
                        parentValue: 'category'
                    };
                }, */
                ruleValue() {
                    return this.dataRule.value;
                },
                ruleField() {
                    if (Array.isArray(this.dataRule.field)) return this.dataRule.field;
                    return [this.dataRule.field];
                },
                ruleOperator() {
                    return this.dataRule.operator;
                },
                ruleCriteriaRecord() {
                    return this.dataRule.criteriaRecord;
                },
                ddOptions() {
                    let currentColumn;
                    if (this.dataRule && this.dataRule.field) {
                        currentColumn = this.data.columns.find((column) => column.field === this.dataRule.field);
                    }
                    if (currentColumn && currentColumn.options) return currentColumn.options;
                    return [];
                }
            },
            methods: {
                ddCreated() {
                    this.$refs['ruleField'].setProperties({ fields: this.$options.fields });
                    this.$refs['ruleField'].setProperties({ value: this.ruleField });
                },
                additionalParamChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    // this.data.rule.additionalParam = args.value;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'additionalParam');
                },
                fieldChange: function (args) {
                    if (!args?.isInteracted) return;
                    args.element = this.$refs['ruleField'].$el;
                    args.value = args.itemData.id;
                    locals.fieldChangeAddInfo(this, args.itemData.id);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'field');
                },
                operatorChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'operator');
                },
                recordTypeChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    this.data.rule.criteriaRecord = args.value;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'criteriaRecord');
                },
                optionChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    if (!args.value) args.value = args.checked;
                    let elemId = 'ruleValue_' + this.data.ruleID;
                    if (!args.element) args.element = this.$refs['ruleValue'].$el;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'value');
                }
            },
            components: {
                'ejs-dropdownlist': defineAsyncComponent(() => import('@common/syncfusion/dropdownList')),
                'ejs-dropdowntree': defineAsyncComponent(() => import('@common/syncfusion/dropdownTree')),
                'ejs-textbox': defineAsyncComponent(() => import('@common/syncfusion/text')),
            }
        });
        let tmpFunc = locals.templateFunc(tmpCmp, templateId);
        this.textTypeTemplateComponent[_this.cId] = tmpFunc;
        return tmpFunc;
    },
    booleanTypeTemplateComponent: {},
    booleanTypeTemplate(_this) {
        if (this.booleanTypeTemplateComponent[_this.cId]) return this.booleanTypeTemplateComponent[_this.cId];
        let templateId = 'booleanTypeTemplate_' + _this.cId + '_' + library.getUniqueID();
        let tmpCmp = vueApp.component(templateId, {
            template: `<div class="e-rule e-rule-template boolean-type-template">
                        <div class="e-rule-filter e-custom-filter">
                            <ejs-dropdowntree :created="ddCreated" :showClearButton="false" :allowFiltering="true" :filterType="'Contains'" :ref="'ruleField'" :changeOnBlur="false" @select='fieldChange'>
                            </ejs-dropdowntree>
                            <div v-show="isAdditionalParamShown">
                                <ejs-dropdownlist
                                    :placeholder="parent.additionalParamPlaceholders[isAdditionalParamShown]"
                                    :fields="{ text: 'text', value: 'value' }"
                                    v-model="ruleAdditionalParam"
                                    @change='additionalParamChange'
                                    :dataSource="parent.additionalParamItems[isAdditionalParamShown]">
                                </ejs-dropdownlist>
                            </div>
                            <div v-show="!parent.showLogicOnly">
                                <ejs-dropdownlist :placeholder="'Record Type'" :fields="{ text: 'text', value: 'value' }" v-model="ruleCriteriaRecord" @change='recordTypeChange' :dataSource="recordTypesItems"></ejs-dropdownlist>
                            </div>
                        </div>
                        <div class="e-rule-operator e-operator">
                            <ejs-dropdownlist :change='operatorChange' :dataSource="operators" :fields='operatorFields' v-model='ruleOperator'>
                            </ejs-dropdownlist>
                        </div>
                        <div class="e-rule-btn e-rule-value-delete">
                            <button class="e-removerule e-rule-delete e-css e-btn e-small e-round">
                                <span class="e-btn-icon e-icons e-delete-icon"/>
                            </button>
                        </div>
                        <div class="clearfix"></div>
                    </div>`,
            data() {
                return {
                    data: {},
                    outputValue: '',
                    operatorFields: {
                        text: 'display',
                        value: 'vueValue'
                    },
                    parent: _this,
                    recordTypesItems: locals.getRecordTypesItems(_this.recordTypesItems)
                };
            },
            created() {
                locals.templateCreated(this, _this);
            },
            computed: {
                dataRule() {
                    return library.cloneObj(this.data.rule, true, true);
                },
                operators() {
                    return locals.getFieldOperators(this);
                },
                isAdditionalParamShown() {
                    let isAdditionalParamShown = false;
                    if (Array.isArray(this.ruleField) && this.ruleField.length) {
                        let tmpField = this.data.columns.find((tmpI) => tmpI['field'] === this.ruleField[0]);
                        isAdditionalParamShown = tmpField?.category === 'org' || tmpField?.category === 'aff' ? tmpField?.category : false;
                        if (!this.parent?.additionalParamItems?.[isAdditionalParamShown]?.length) isAdditionalParamShown = false;
                    }
                    return isAdditionalParamShown;
                },
                ruleAdditionalParam() {
                    return this.dataRule.additionalParam;
                },
                /* fields() {
                    return {
                        dataSource: _this.columns,
                        text: 'label',
                        value: 'field',
                        hasChildren: 'hasChild',
                        parentValue: 'category',
                        selectable: 'selectable',
                        htmlAttributes: 'htmlAttributes'
                    };
                }, */
                ruleValue() {
                    return this.dataRule.value;
                },
                ruleField() {
                    if (Array.isArray(this.dataRule.field)) return this.dataRule.field;
                    return [this.dataRule.field];
                },
                ruleCriteriaRecord() {
                    return this.dataRule.criteriaRecord;
                },
                ruleOperator() {
                    return this.dataRule.operator || 'equal';
                },
                ddOptions() {
                    let currentColumn;
                    if (this.dataRule && this.dataRule.field) {
                        currentColumn = this.data.columns.find((column) => column.field === this.dataRule.field);
                    }
                    if (currentColumn && currentColumn.options) return currentColumn.options;
                    return [];
                }
            },
            methods: {
                ddCreated() {
                    this.$refs['ruleField'].setProperties({ fields: this.$options.fields });
                    this.$refs['ruleField'].setProperties({ value: this.ruleField });
                },
                additionalParamChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    // this.data.rule.additionalParam = args.value;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'additionalParam');
                },
                fieldChange: function (args) {
                    if (!args?.isInteracted) return;
                    args.element = this.$refs['ruleField'].$el;
                    args.value = args.itemData.id;
                    locals.fieldChangeAddInfo(this, args.itemData.id);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'field');
                },
                recordTypeChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    this.data.rule.criteriaRecord = args.value;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'criteriaRecord');
                },
                operatorChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'operator');
                },
                optionChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    if (!args.value) args.value = args.checked;
                    let elemId = 'ruleValue_' + this.data.ruleID;
                    if (!args.element) args.element = this.$refs['ruleValue'].$el;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'value');
                }
            },
            components: {
                'ejs-dropdownlist': defineAsyncComponent(() => import('@common/syncfusion/dropdownList')),
                'ejs-dropdowntree': defineAsyncComponent(() => import('@common/syncfusion/dropdownTree'))
            }
        });
        let tmpFunc = locals.templateFunc(tmpCmp, templateId);
        this.booleanTypeTemplateComponent[_this.cId] = tmpFunc;
        return tmpFunc;
    },
    numericTypeTemplateComponent: {},
    numericTypeTemplate(_this) {
        if (this.numericTypeTemplateComponent[_this.cId]) return this.numericTypeTemplateComponent[_this.cId];
        let templateId = 'numericTypeTemplate_' + _this.cId + '_' + library.getUniqueID();
        let tmpCmp = vueApp.component(templateId, {
            template: `<div class="e-rule e-rule-template numeric-type-template">
                        <div class="e-rule-filter e-custom-filter">
                            <ejs-dropdowntree :created="ddCreated" :showClearButton="false" :allowFiltering="true" :filterType="'Contains'" :ref="'ruleField'" :changeOnBlur="false" @select='fieldChange'>
                            </ejs-dropdowntree>
                            <div v-show="isAdditionalParamShown">
                                <ejs-dropdownlist
                                    :placeholder="parent.additionalParamPlaceholders[isAdditionalParamShown]"
                                    :fields="{ text: 'text', value: 'value' }"
                                    v-model="ruleAdditionalParam"
                                    @change='additionalParamChange'
                                    :dataSource="parent.additionalParamItems[isAdditionalParamShown]">
                                </ejs-dropdownlist>
                            </div>
                            <div v-show="!parent.showLogicOnly">
                                <ejs-dropdownlist :placeholder="'Record Type'" :fields="{ text: 'text', value: 'value' }" v-model="ruleCriteriaRecord" @change='recordTypeChange' :dataSource="recordTypesItems"></ejs-dropdownlist>
                            </div>
                        </div>
                        <div class="e-rule-operator e-operator">
                            <ejs-dropdownlist :change='operatorChange' :dataSource="operators" :fields='operatorFields' v-model='ruleOperator'>
                            </ejs-dropdownlist>
                        </div>
                        <div class="e-rule-value e-value" v-if="showInput">
                            <ejs-numerictextbox format="#######################" :ref="'ruleValue'" :value="ruleValue" :change="optionChange" :min="0"></ejs-numerictextbox>
                        </div>
                        <div class="e-rule-btn e-rule-value-delete">
                            <button class="e-removerule e-rule-delete e-css e-btn e-small e-round">
                                <span class="e-btn-icon e-icons e-delete-icon"/>
                            </button>
                        </div>
                        <div class="clearfix"></div>
                    </div>`,
            data() {
                return {
                    data: {},
                    outputValue: '',
                    operatorFields: {
                        text: 'display',
                        value: 'vueValue'
                    },
                    parent: _this,
                    recordTypesItems: locals.getRecordTypesItems(_this.recordTypesItems)
                };
            },
            created() {
                locals.templateCreated(this, _this);
            },
            computed: {
                dataRule() {
                    return library.cloneObj(this.data.rule, true, true);
                },
                operators() {
                    return locals.getFieldOperators(this);
                },
                isAdditionalParamShown() {
                    let isAdditionalParamShown = false;
                    if (Array.isArray(this.ruleField) && this.ruleField.length) {
                        let tmpField = this.data.columns.find((tmpI) => tmpI['field'] === this.ruleField[0]);
                        isAdditionalParamShown = tmpField?.category === 'org' || tmpField?.category === 'aff' ? tmpField?.category : false;
                        if (!this.parent?.additionalParamItems?.[isAdditionalParamShown]?.length) isAdditionalParamShown = false;
                    }
                    return isAdditionalParamShown;
                },
                ruleAdditionalParam() {
                    return this.dataRule.additionalParam;
                },
                showInput() {
                    let tmpOperator = this.operators.find((tmpI) => tmpI['vueValue'] === this.ruleOperator);
                    return tmpOperator && tmpOperator.input ? tmpOperator.input : false;
                },
                /* fields() {
                    return {
                        dataSource: _this.columns,
                        text: 'label',
                        value: 'field',
                        hasChildren: 'hasChild',
                        parentValue: 'category'
                    };
                }, */
                ruleValue() {
                    return this.dataRule.value;
                },
                ruleField() {
                    if (Array.isArray(this.dataRule.field)) return this.dataRule.field;
                    return [this.dataRule.field];
                },
                ruleCriteriaRecord() {
                    return this.dataRule.criteriaRecord;
                },
                ruleOperator() {
                    return this.dataRule.operator || 'equal';
                },
                ddOptions() {
                    let currentColumn;
                    if (this.dataRule && this.dataRule.field) {
                        currentColumn = this.data.columns.find((column) => column.field === this.dataRule.field);
                    }
                    if (currentColumn && currentColumn.options) return currentColumn.options;
                    return [];
                }
            },
            methods: {
                ddCreated() {
                    this.$refs['ruleField'].setProperties({ fields: this.$options.fields });
                    this.$refs['ruleField'].setProperties({ value: this.ruleField });
                },
                additionalParamChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    // this.data.rule.additionalParam = args.value;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'additionalParam');
                },
                fieldChange: function (args) {
                    if (!args?.isInteracted) return;
                    args.element = this.$refs['ruleField'].$el;
                    args.value = args.itemData.id;
                    locals.fieldChangeAddInfo(this, args.itemData.id);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'field');
                },
                recordTypeChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    this.data.rule.criteriaRecord = args.value;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'criteriaRecord');
                },
                operatorChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'operator');
                },
                optionChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    if (!args.value) args.value = args.checked;
                    if (!args.element) args.element = this.$refs['ruleValue'].$el;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'value');
                }
            },
            components: {
                'ejs-dropdownlist': defineAsyncComponent(() => import('@common/syncfusion/dropdownList')),
                'ejs-dropdowntree': defineAsyncComponent(() => import('@common/syncfusion/dropdownTree')),
                'ejs-numerictextbox': defineAsyncComponent(() => import('@common/syncfusion/numeric')),
            }
        });
        let tmpFunc = locals.templateFunc(tmpCmp, templateId);
        this.numericTypeTemplateComponent[_this.cId] = tmpFunc;
        return tmpFunc;
    },
    defaultFieldTemplateComponent: {},
    defaultFieldTemplate(_this) {
        if (this.defaultFieldTemplateComponent[_this.cId]) return this.defaultFieldTemplateComponent[_this.cId];
        let templateId = 'defaultFieldTemplate_' + _this.cId + '_' + library.getUniqueID();
        let tmpCmp = vueApp.component(templateId, {
            template: `<div class="e-rule e-rule-template default-type-template">
                        <div class="e-rule-filter e-custom-filter">
                            <ejs-dropdowntree :created="ddCreated" :showClearButton="false" :allowFiltering="true" :filterType="'Contains'" :ref="'ruleField'" :changeOnBlur="false" @select='fieldChange'>
                            </ejs-dropdowntree>
                            <div v-show="isAdditionalParamShown">
                                <ejs-dropdownlist
                                    :placeholder="parent.additionalParamPlaceholders[isAdditionalParamShown]"
                                    :fields="{ text: 'text', value: 'value' }"
                                    v-model="ruleAdditionalParam"
                                    @change='additionalParamChange'
                                    :dataSource="parent.additionalParamItems[isAdditionalParamShown]">
                                </ejs-dropdownlist>
                            </div>
                            <div v-show="!parent.showLogicOnly">
                                <ejs-dropdownlist :placeholder="'Record Type'" :fields="{ text: 'text', value: 'value' }" v-model="ruleCriteriaRecord" @change='recordTypeChange' :dataSource="recordTypesItems"></ejs-dropdownlist>
                            </div>
                        </div>
                        <div class="e-rule-operator e-operator">
                            <ejs-dropdownlist :change='operatorChange' :dataSource="operators" :fields='operatorFields' v-model='ruleOperator'>
                            </ejs-dropdownlist>
                        </div>
                        <div class="e-rule-value e-value" v-show="showInput">
                            <ejs-textbox v-if="data.rule.type==='string' || data.rule.type==='array'" :ref="'ruleValue'" v-model="ruleValue" :change="optionChange"></ejs-textbox>
                            <ejs-numerictextbox format="#######################" v-if="data.rule.type==='numeric'" :ref="'ruleValue'" v-model="ruleValue" :change="optionChange" :min="0"></ejs-numerictextbox>
                            <ejs-checkbox v-if="data.rule.type==='boolean'" :ref="'ruleValue'" v-model="ruleValue" :checked="ruleValue" :change="optionChange" ></ejs-checkbox>
                        </div>
                        <div class="e-rule-btn e-rule-value-delete">
                            <button class="e-removerule e-rule-delete e-css e-btn e-small e-round">
                                <span class="e-btn-icon e-icons e-delete-icon"/>
                            </button>
                        </div>
                        <div class="clearfix"></div>
                    </div>`,
            data() {
                return {
                    data: {},
                    outputValue: '',
                    operatorFields: {
                        text: 'display',
                        value: 'vueValue'
                    },
                    parent: _this,
                    recordTypesItems: locals.getRecordTypesItems(_this.recordTypesItems)
                };
            },
            created() {
                locals.templateCreated(this, _this);
            },
            computed: {
                dataRule() {
                    return library.cloneObj(this.data.rule, true, true);
                },
                operators() {
                    return locals.getFieldOperators(this);
                },
                isAdditionalParamShown() {
                    let isAdditionalParamShown = false;
                    if (Array.isArray(this.ruleField) && this.ruleField.length) {
                        let tmpField = this.data.columns.find((tmpI) => tmpI['field'] === this.ruleField[0]);
                        isAdditionalParamShown = tmpField?.category === 'org' || tmpField?.category === 'aff' ? tmpField?.category : false;
                        if (!this.parent?.additionalParamItems?.[isAdditionalParamShown]?.length) isAdditionalParamShown = false;
                    }
                    return isAdditionalParamShown;
                },
                ruleAdditionalParam() {
                    return this.dataRule.additionalParam;
                },
                showInput() {
                    let tmpOperator = this.operators.find((tmpI) => tmpI['vueValue'] === this.ruleOperator);
                    return tmpOperator && tmpOperator.input ? tmpOperator.input : false;
                },
                /* fields() {
                    return {
                        dataSource: _this.columns,
                        text: 'label',
                        value: 'field',
                        hasChildren: 'hasChild',
                        parentValue: 'category'
                    };
                }, */
                ruleValue() {
                    return this.dataRule.value;
                },
                ruleField() {
                    if (Array.isArray(this.dataRule.field)) return this.dataRule.field;
                    return [this.dataRule.field];
                },
                ruleCriteriaRecord() {
                    return this.dataRule.criteriaRecord;
                },
                ruleOperator() {
                    return this.dataRule.operator || 'equal';
                },
                ddOptions() {
                    let currentColumn;
                    if (this.dataRule && this.dataRule.field) {
                        currentColumn = this.data.columns.find((column) => column.field === this.dataRule.field);
                    }
                    if (currentColumn && currentColumn.options) return currentColumn.options;
                    return [];
                }
            },
            methods: {
                ddCreated() {
                    this.$refs['ruleField'].setProperties({ fields: this.$options.fields });
                    this.$refs['ruleField'].setProperties({ value: this.ruleField });
                },
                additionalParamChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    // this.data.rule.additionalParam = args.value;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'additionalParam');
                },
                fieldChange: function (args) {
                    if (!args?.isInteracted) return;
                    args.element = this.$refs['ruleField'].$el;
                    args.value = args.itemData.id;
                    locals.fieldChangeAddInfo(this, args.itemData.id);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'field');
                },
                recordTypeChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    this.data.rule.criteriaRecord = args.value;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'criteriaRecord');
                },
                operatorChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'operator');
                },
                optionChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    if (!args.value) args.value = args.checked;
                    let elemId = 'ruleValue_' + this.data.ruleID;
                    if (!args.element) args.element = this.$refs['ruleValue'].$el;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'value');
                }
            },
            components: {
                'ejs-dropdownlist': defineAsyncComponent(() => import('@common/syncfusion/dropdownList')),
                'ejs-dropdowntree': defineAsyncComponent(() => import('@common/syncfusion/dropdownTree')),
                'ejs-numerictextbox': defineAsyncComponent(() => import('@common/syncfusion/numeric')),
                'ejs-textbox': defineAsyncComponent(() => import('@common/syncfusion/text')),
                "ejs-checkbox": defineAsyncComponent(() => import('@common/syncfusion/checkbox'))
            }
        });
        let tmpFunc = locals.templateFunc(tmpCmp, templateId);
        this.defaultFieldTemplateComponent[_this.cId] = tmpFunc;
        return tmpFunc;
    },
    dateTypeTemplateComponent: {},
    dateTypeTemplate(_this) {
        if (this.dateTypeTemplateComponent[_this.cId]) return this.dateTypeTemplateComponent[_this.cId];
        let templateId = 'dateTypeTemplate_' + _this.cId + '_' + library.getUniqueID();
        let tmpCmp = vueApp.component(templateId, {
            template: `<div class="e-rule e-rule-template date-type-template">
                <div class="e-rule-filter e-custom-filter">
                    <ejs-dropdowntree :created="ddCreated" :showClearButton="false" :allowFiltering="true" :filterType="'Contains'" :ref="'ruleField'"   :changeOnBlur="false" @select='fieldChange'>
                    </ejs-dropdowntree>
                    <div v-show="isAdditionalParamShown">
                        <ejs-dropdownlist
                            :placeholder="parent.additionalParamPlaceholders[isAdditionalParamShown]"
                            :fields="{ text: 'text', value: 'value' }"
                            v-model="ruleAdditionalParam"
                            @change='additionalParamChange'
                            :dataSource="parent.additionalParamItems[isAdditionalParamShown]">
                        </ejs-dropdownlist>
                    </div>
                    <div v-show="!parent.showLogicOnly">
                        <ejs-dropdownlist :placeholder="'Record Type'" :fields="{ text: 'text', value: 'value' }" v-model="ruleCriteriaRecord" @change='recordTypeChange' :dataSource="recordTypesItems"></ejs-dropdownlist>
                    </div>
                </div>
                <div class="e-rule-operator e-operator">
                    <ejs-dropdownlist :change='operatorChange' :dataSource="operators" :fields='operatorFields' v-model='ruleOperator'>
                    </ejs-dropdownlist>
                </div>
                <div class="e-rule-sub-operator e-operator">
                    <div v-if="showInput || showRange">
                        <div class="fl" v-if="showRange">
                            <div class="fl">
                                <ejs-dropdownlist :id="'datePeriodFrom_' + data.ruleID" :dataSource="datePeriodOptions"  :cssClass="'e-template'" v-model="ruleValue['datePeriodFrom']" :fields="ddFields" :change="optionChange"></ejs-dropdownlist>
                                <br>
                                <div v-if="datePeriodFromInputType === 'numeric'">
                                    <ejs-numerictextbox
                                        :id="'datePeriodAdditionalFrom_' + data.ruleID"
                                        :cssClass="'e-template'"
                                        :format="'##'"
                                        :min="1"
                                        :max="999"
                                        v-model="ruleValue['dateValueFrom']"
                                        :change="optionChange"
                                    ></ejs-numerictextbox>
                                </div>
                                <div v-if="datePeriodFromInputType === 'date'">
                                    <ejs-datepicker :id="'dateValueFrom_' + data.ruleID" v-model="ruleValue['dateValueFrom']" :cssClass="'e-template'" :change="optionChange"></ejs-datepicker>
                                </div>
                            </div>
                            <div class="fl">
                                <ejs-dropdownlist :id="'datePeriodTo_' + data.ruleID" :cssClass="'e-template'" :dataSource="datePeriodOptions" v-model="ruleValue['datePeriodTo']" :fields="ddFields" :change="optionChange"></ejs-dropdownlist>
                                <br>
                                <div v-if="datePeriodToInputType === 'numeric'">
                                    <ejs-numerictextbox
                                        :id="'datePeriodAdditionalTo_' + data.ruleID"
                                        :cssClass="'e-template'"
                                        :format="'##'"
                                        :min="1"
                                        :max="999"
                                        v-model="ruleValue['dateValueTo']"
                                        :change="optionChange"
                                    ></ejs-numerictextbox>
                                </div>
                                <div v-if="datePeriodToInputType === 'date'">
                                    <ejs-datepicker :id="'dateValueTo_' + data.ruleID" :cssClass="'e-template'" v-model="ruleValue['dateValueTo']" :change="optionChange"></ejs-datepicker>
                                </div>
                            </div>
                        </div>
                        <div class="fl" v-else>
                            <div class="fl">
                                <ejs-dropdownlist :id="'datePeriod_' + data.ruleID" :cssClass="'e-template'" :dataSource="datePeriodOptions" v-model="ruleValue['datePeriod']" :fields="ddFields" :change="optionChange"></ejs-dropdownlist>
                            </div>
                            <div class="fl">
                                <div v-if="datePeriodInputType === 'numeric'">
                                    <div class="fl">
                                        <ejs-numerictextbox
                                            :id="'datePeriodAdditional_' + data.ruleID"
                                            :cssClass="'e-template'"
                                            :format="'##'"
                                            :min="1"
                                            :max="999"
                                            v-model="ruleValue['dateValue']"
                                            :change="optionChange"
                                        ></ejs-numerictextbox>
                                    </div>
                                    <div class="fl">
                                        <ejs-dropdownlist v-if="ruleValue['datePeriod'] === 144 || ruleValue['datePeriod'] === 145" :change='optionChange' :dataSource="valueAdditionalParamItems" :fields='valueAdditionalParamFields' v-model="ruleValue['valueAdditionalParam']">
                                        </ejs-dropdownlist>
                                    </div>
                                </div>
                                <div v-if="datePeriodInputType === 'date'">
                                    <ejs-datepicker :ref="'ruleValue'" :cssClass="'e-template'" v-model="ruleValue['dateValue']" :change="optionChange"></ejs-datepicker>
                                </div>
                            </div>
                        </div>
                        <div class="e-rule-btn e-rule-value-delete fl">
                            <button class="e-removerule e-rule-delete e-css e-btn e-small e-round">
                                <span class="e-btn-icon e-icons e-delete-icon"/>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>
            </div>`,
            data() {
                return {
                    parent: _this,
                    recordTypesItems: locals.getRecordTypesItems(_this.recordTypesItems),
                    data: {},
                    ddFields: {
                        text: 'display',
                        value: 'vueValue'
                    },
                    operatorFields: {
                        text: 'display',
                        value: 'vueValue'
                    },
                    valueAdditionalParamItems: [
                        {
                            text: 'Weeks',
                            value: '0'
                        },
                        {
                            text: 'Months',
                            value: '1'
                        },
                        {
                            text: 'Years',
                            value: '2'
                        }
                    ],
                    valueAdditionalParamFields: {
                        text: 'text',
                        value: 'value'
                    },
                    inputType: 'date',
                    subOperators: [...[{
                        display: 'specific',
                        vueValue: 0,
                        input: 1,
                        inputType: 'date',
                        canBeUsedWith: ['input', 'range']
                    }], ..._this.operators['dateSubOperators']],
                    refreshKey: 0,
                    errorMessageIsShown: false
                };
            },
            created() {
                locals.templateCreated(this, _this);
            },
            computed: {
                dataRule() {
                    return library.cloneObj(this.data.rule, true, true);
                },
                operators() {
                    return locals.getFieldOperators(this);
                },
                isAdditionalParamShown() {
                    let isAdditionalParamShown = false;
                    if (Array.isArray(this.ruleField) && this.ruleField.length) {
                        let tmpField = this.data.columns.find((tmpI) => tmpI['field'] === this.ruleField[0]);
                        isAdditionalParamShown = tmpField?.category === 'org' || tmpField?.category === 'aff' ? tmpField?.category : false;
                        if (!this.parent?.additionalParamItems?.[isAdditionalParamShown]?.length) isAdditionalParamShown = false;
                    }
                    return isAdditionalParamShown;
                },
                ruleAdditionalParam() {
                    return this.dataRule.additionalParam;
                },
                showInput() {
                    let tmpOperator = this.operators.find((tmpI) => tmpI['vueValue'] === this.ruleOperator);
                    return tmpOperator && tmpOperator.input ? tmpOperator.input : false;
                },
                showRange() {
                    let tmpOperator = this.operators.find((tmpI) => tmpI['vueValue'] === this.ruleOperator);
                    return tmpOperator && tmpOperator.range ? tmpOperator.range : false;
                },
                datePeriodFromInputType() {
                    let tmpOperator = this.subOperators.find((tmpI) => tmpI['vueValue'] === this.ruleValue['datePeriodFrom']);
                    return tmpOperator && tmpOperator.inputType ? tmpOperator.inputType : false;
                },
                datePeriodToInputType() {
                    let tmpOperator = this.subOperators.find((tmpI) => tmpI['vueValue'] === this.ruleValue['datePeriodTo']);
                    return tmpOperator && tmpOperator.inputType ? tmpOperator.inputType : false;
                },
                datePeriodInputType() {
                    let tmpOperator = this.subOperators.find((tmpI) => tmpI['vueValue'] === this.ruleValue['datePeriod']);
                    return tmpOperator && tmpOperator.inputType ? tmpOperator.inputType : false;
                },
                datePeriodOptions() {
                    let tmpOptions = [];
                    for (let i in this.subOperators) {
                        if (typeof this.subOperators[i]['canBeUsedWith'] === 'undefined') continue;
                        if (this.showInput && this.subOperators[i]['canBeUsedWith'].indexOf('input') === -1) continue;
                        if (this.showRange && this.subOperators[i]['canBeUsedWith'].indexOf('range') === -1) continue;
                        tmpOptions.push(this.subOperators[i]);
                    }
                    return tmpOptions;
                },
                /* fields() {
                    return {
                        dataSource: _this.columns,
                        text: 'label',
                        value: 'field',
                        hasChildren: 'hasChild',
                        parentValue: 'category'
                    };
                }, */
                ruleField() {
                    if (Array.isArray(this.dataRule.field)) return this.dataRule.field;
                    return [this.dataRule.field];
                },
                ruleCriteriaRecord() {
                    return this.dataRule.criteriaRecord;
                },
                ruleValue() {
                    // do not remove refreshKey!!!
                    let refreshKey = this.refreshKey;
                    if (this.dataRule.value !== null && library.isJson(this.dataRule.value)) {
                        let ruleValue = JSON.parse(this.dataRule.value);
                        if (!ruleValue.datePeriodFrom) ruleValue.datePeriodFrom = 0;
                        if (ruleValue.dateValue && typeof ruleValue?.dateValue?.indexOf === 'function' && ruleValue.dateValue.indexOf('-') !== -1) {
                            ruleValue.dateValue = moment(ruleValue.dateValue)?._d || null;
                        }
                        if (ruleValue.dateValueFrom && typeof ruleValue?.dateValueFrom?.indexOf === 'function' && ruleValue.dateValueFrom.indexOf('-') !== -1) {
                            ruleValue.dateValueFrom = moment(ruleValue.dateValueFrom)?._d || null;
                        }
                        if (ruleValue.dateValueTo && typeof ruleValue?.dateValueTo?.indexOf === 'function' && ruleValue.dateValueTo.indexOf('-') !== -1) {
                            ruleValue.dateValueTo = moment(ruleValue.dateValueTo)?._d || null;
                        }
                        if (!ruleValue.valueAdditionalParam && (ruleValue['datePeriod'] === 144 || ruleValue['datePeriod'] === 145)) {
                            ruleValue.valueAdditionalParam = "0";
                        }
                        return library.cloneObj(ruleValue);
                    }
                    return {
                        datePeriodFrom: 0,
                        dateValueFrom: null,
                        datePeriodTo: 0,
                        dateValueTo: null,
                        datePeriod: 0,
                        dateValue: null,
                        valueAdditionalParamFields: "0"
                    };
                },
                ruleOperator() {
                    return this.dataRule.operator || 'equal';
                },
            },
            mounted() {
                this.isValid(false, this.ruleValue);
            },
            methods: {
                ddCreated() {
                    this.$refs['ruleField'].setProperties({ fields: this.$options.fields });
                    this.$refs['ruleField'].setProperties({ value: this.ruleField });
                },
                additionalParamChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    // this.data.rule.additionalParam = args.value;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'additionalParam');
                },
                fieldChange: function (args) {
                    if (!args?.isInteracted) return;
                    args.element = this.$refs['ruleField'].$el;
                    args.value = args.itemData.id;
                    locals.fieldChangeAddInfo(this, args.itemData.id);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'field');
                },
                recordTypeChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    this.data.rule.criteriaRecord = args.value;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'criteriaRecord');
                },
                operatorChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'operator');
                },
                isInputVisible(datePeriod) {
                    let tmpOperator = this.subOperators.find((tmpI) => tmpI['vueValue'] === datePeriod);
                    return !!(tmpOperator && tmpOperator.inputType);
                },
                isInputVisibleType(datePeriod) {
                    let tmpOperator = this.subOperators.find((tmpI) => tmpI['vueValue'] === datePeriod);
                    return tmpOperator && tmpOperator.inputType ? tmpOperator.inputType : false;
                },
                isShowRange(datePeriod) {
                    let tmpOperator = this.operators.find((tmpI) => tmpI['vueValue'] === datePeriod);
                    return tmpOperator && tmpOperator.range ? tmpOperator.range : false;
                },
                isValid: function (args, ruleValue) {
                    if (this.ruleOperator !== 'isempty' && this.ruleOperator !== 'isnotempty' && !this.isShowRange(this.ruleOperator)) {
                        if (this.isInputVisibleType(ruleValue.datePeriod) === 'date') {
                            if (!ruleValue.dateValue) {
                                // if (this.errorMessageIsShown) return false;
                                // this.errorMessageIsShown = true;
                                this.parent.$emit('update:propValidationErrors', ['Please select specific day']);
                                /* library.showDialog('Please select specific day', () => {
                                    this.errorMessageIsShown = false;
                                    setTimeout(() => {
                                        // eslint-disable-next-line no-empty
                                        try { this.$refs['ruleValue'].$el.focus(); } catch (e) {}
                                    }, 500);
                                    return true;
                                }, () => {
                                    this.errorMessageIsShown = false;
                                    setTimeout(() => {
                                        // eslint-disable-next-line no-empty
                                        try { this.$refs['ruleValue'].$el.focus(); } catch (e) {}
                                    }, 500);
                                    return true;
                                }, { showAsAlert: true }); */
                                return false;
                            }
                        } else if (this.isInputVisibleType(ruleValue.datePeriod) === 'numeric') {
                            if (!ruleValue.dateValue) {
                                // if (this.errorMessageIsShown) return false;
                                // this.errorMessageIsShown = true;
                                this.parent.$emit('update:propValidationErrors', ['Please select number of days']);
                                /* library.showDialog('Please select number of days', () => {
                                    this.errorMessageIsShown = false;
                                    setTimeout(() => {
                                        // eslint-disable-next-line no-empty
                                        try { document.getElementById('datePeriodAdditional_' + this.data.ruleID).focus(); } catch (e) {}
                                    }, 500);
                                    return true;
                                },
                                () => {
                                    this.errorMessageIsShown = false;
                                    setTimeout(() => {
                                        // eslint-disable-next-line no-empty
                                        try { document.getElementById('datePeriodAdditional_' + this.data.ruleID).focus(); } catch (e) {}
                                    }, 500);
                                    return true;
                                }, { showAsAlert: true }); */
                                return false;
                            }
                        }
                    }
                    this.parent.$emit('update:propValidationErrors', []);
                    return true;
                },
                optionChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    if (args.event === null) return;
                    let ruleValue = library.cloneObj(this.ruleValue);
                    if (ruleValue.dateValue instanceof Date) {
                        ruleValue.dateValue = moment(ruleValue.dateValue).format('YYYY-MM-DD');
                    }
                    if (ruleValue.dateValueFrom instanceof Date) {
                        ruleValue.dateValueFrom = moment(ruleValue.dateValueFrom).format('YYYY-MM-DD');
                    }
                    if (ruleValue.dateValueTo instanceof Date) {
                        ruleValue.dateValueTo = moment(ruleValue.dateValueTo).format('YYYY-MM-DD');
                    }
                    if (this.showRange) {
                        ruleValue.dateValue = null;
                        ruleValue.datePeriod = 0;
                        if (this.isInputVisible(ruleValue.datePeriodFrom) === false) {
                            ruleValue.dateValueFrom = null;
                        }
                        if (this.isInputVisible(ruleValue.datePeriodTo) === false) {
                            ruleValue.dateValueTo = null;
                        }
                    } else {
                        ruleValue.datePeriodFrom = 0;
                        ruleValue.dateValueFrom = null;
                        ruleValue.datePeriodTo = 0;
                        ruleValue.dateValueTo = null;
                        if (this.isInputVisible(ruleValue.datePeriod) === false) {
                            ruleValue.dateValue = null;
                        }
                    }
                    this.isValid(args, ruleValue);

                    let queryBuilderIDParts = this.data.ruleID.split('_');
                    if (queryBuilderIDParts.length) {
                        let queryBuilderID = queryBuilderIDParts[0] + '_' + queryBuilderIDParts[1];
                        let queryBuilderObj = getComponent(document.getElementById(queryBuilderID), 'query-builder');
                        let elem = args.element || args?.event?.srcElement || args?.model?.element;
                        if (elem && queryBuilderObj) {
                            queryBuilderObj.notifyChange(JSON.stringify(ruleValue), elem, 'value');
                            this.data.rule.value = JSON.stringify(ruleValue);
                            // this.refreshKey++;
                        }
                    }
                }
            },
            components: {
                'ejs-dropdownlist': defineAsyncComponent(() => import('@common/syncfusion/dropdownList')),
                'ejs-datepicker': defineAsyncComponent(() => import('@common/syncfusion/datePicker')),
                'ejs-numerictextbox': defineAsyncComponent(() => import('@common/syncfusion/numeric')),
                'ejs-dropdowntree': defineAsyncComponent(() => import('@common/syncfusion/dropdownTree'))
            }
        });
        let tmpFunc = locals.templateFunc(tmpCmp, templateId);
        this.dateTypeTemplateComponent[_this.cId] = tmpFunc;
        return tmpFunc;
    },
    timeTypeTemplateComponent: {},
    timeTypeTemplate(_this) {
        if (this.timeTypeTemplateComponent[_this.cId]) return this.timeTypeTemplateComponent[_this.cId];
        let templateId = 'timeTypeTemplate_' + _this.cId + '_' + library.getUniqueID();
        let tmpCmp = vueApp.component(templateId, {
            template: `<div class="e-rule e-rule-template time-type-template">
                <div class="e-rule-filter e-custom-filter">
                    <ejs-dropdowntree :created="ddCreated" :showClearButton="false" :allowFiltering="true" :filterType="'Contains'" :ref="'ruleField'"   :changeOnBlur="false" @select='fieldChange'>
                    </ejs-dropdowntree>
                    <div v-show="isAdditionalParamShown">
                        <ejs-dropdownlist
                            :placeholder="parent.additionalParamPlaceholders[isAdditionalParamShown]"
                            :fields="{ text: 'text', value: 'value' }"
                            v-model="ruleAdditionalParam"
                            @change='additionalParamChange'
                            :dataSource="parent.additionalParamItems[isAdditionalParamShown]">
                        </ejs-dropdownlist>
                    </div>
                    <div v-show="!parent.showLogicOnly">
                        <ejs-dropdownlist :placeholder="'Record Type'" :fields="{ text: 'text', value: 'value' }" v-model="ruleCriteriaRecord" @change='recordTypeChange' :dataSource="recordTypesItems"></ejs-dropdownlist>
                    </div>
                </div>
                <div class="e-rule-operator e-operator">
                    <ejs-dropdownlist :change='operatorChange' :dataSource="operators" :fields='operatorFields' v-model='ruleOperator'>
                    </ejs-dropdownlist>
                </div>
                <div class="e-rule-value e-value" v-if="showInput">
                    <ejs-timepicker :ref="'ruleValue'" v-model="ruleValue" :change="optionChange"></ejs-timepicker>
                </div>
                <div class="e-rule-btn e-rule-value-delete">
                    <button class="e-removerule e-rule-delete e-css e-btn e-small e-round">
                        <span class="e-btn-icon e-icons e-delete-icon"/>
                    </button>
                </div>
                <div class="clearfix"></div>
            </div>`,
            data() {
                return {
                    parent: _this,
                    recordTypesItems: locals.getRecordTypesItems(_this.recordTypesItems),
                    data: {},
                    ddFields: {
                        text: 'text',
                        value: 'value'
                    },
                    operatorFields: {
                        text: 'display',
                        value: 'vueValue'
                    }
                };
            },
            created() {
                locals.templateCreated(this, _this);
            },
            computed: {
                dataRule() {
                    return library.cloneObj(this.data.rule, true, true);
                },
                operators() {
                    return locals.getFieldOperators(this);
                },
                isAdditionalParamShown() {
                    let isAdditionalParamShown = false;
                    if (Array.isArray(this.ruleField) && this.ruleField.length) {
                        let tmpField = this.data.columns.find((tmpI) => tmpI['field'] === this.ruleField[0]);
                        isAdditionalParamShown = tmpField?.category === 'org' || tmpField?.category === 'aff' ? tmpField?.category : false;
                        if (!this.parent?.additionalParamItems?.[isAdditionalParamShown]?.length) isAdditionalParamShown = false;
                    }
                    return isAdditionalParamShown;
                },
                ruleAdditionalParam() {
                    return this.dataRule.additionalParam;
                },
                showInput() {
                    let tmpOperator = this.operators.find((tmpI) => tmpI['vueValue'] === this.ruleOperator);
                    return tmpOperator && tmpOperator.input ? tmpOperator.input : false;
                },
                /* fields() {
                    return {
                        dataSource: _this.columns,
                        text: 'label',
                        value: 'field',
                        hasChildren: 'hasChild',
                        parentValue: 'category'
                    };
                }, */
                ruleField() {
                    if (Array.isArray(this.dataRule.field)) return this.dataRule.field;
                    return [this.dataRule.field];
                },
                ruleCriteriaRecord() {
                    return this.dataRule.criteriaRecord;
                },
                ruleValue() {
                    return this.dataRule.value;
                },
                ruleOperator() {
                    return this.dataRule.operator || 'equal';
                },
            },
            methods: {
                ddCreated() {
                    this.$refs['ruleField'].setProperties({ fields: this.$options.fields });
                    this.$refs['ruleField'].setProperties({ value: this.ruleField });
                },
                additionalParamChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    // this.data.rule.additionalParam = args.value;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'additionalParam');
                },
                fieldChange: function (args) {
                    if (!args?.isInteracted) return;
                    args.element = this.$refs['ruleField'].$el;
                    args.value = args.itemData.id;
                    locals.fieldChangeAddInfo(this, args.itemData.id);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'field');
                },
                recordTypeChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    this.data.rule.criteriaRecord = args.value;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'criteriaRecord');
                },
                operatorChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'operator');
                },
                optionChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'value');
                }
            },
            components: {
                'ejs-dropdownlist': defineAsyncComponent(() => import('@common/syncfusion/dropdownList')),
                'ejs-timepicker': defineAsyncComponent(() => import('@common/syncfusion/timePicker')),
                'ejs-dropdowntree': defineAsyncComponent(() => import('@common/syncfusion/dropdownTree'))
            }
        });
        let tmpFunc = locals.templateFunc(tmpCmp, templateId);
        this.timeTypeTemplateComponent[_this.cId] = tmpFunc;
        return tmpFunc;
    },
    listTypeTemplateComponent: {},
    listTypeTemplate(_this) {
        if (this.listTypeTemplateComponent[_this.cId]) return this.listTypeTemplateComponent[_this.cId];
        let templateId = 'listTypeTemplate_' + _this.cId + '_' + library.getUniqueID();
        let tmpCmp = vueApp.component(templateId, {
            template: `<div class="e-rule e-rule-template list-type-template">
                        <div class="e-rule-filter e-custom-filter">
                            <ejs-dropdowntree :created="ddCreated" :showClearButton="false" :allowFiltering="true" :filterType="'Contains'" :ref="'ruleField'" :changeOnBlur="false" @select='fieldChange'>
                            </ejs-dropdowntree>
                            <div v-show="isAdditionalParamShown">
                                <ejs-dropdownlist
                                    :placeholder="parent.additionalParamPlaceholders[isAdditionalParamShown]"
                                    :fields="{ text: 'text', value: 'value' }"
                                    v-model="ruleAdditionalParam"
                                    @change='additionalParamChange'
                                    :dataSource="parent.additionalParamItems[isAdditionalParamShown]">
                                </ejs-dropdownlist>
                            </div>
                            <div v-show="!parent.showLogicOnly">
                                <ejs-dropdownlist :placeholder="'Record Type'" :fields="{ text: 'text', value: 'value' }" v-model="ruleCriteriaRecord" @change='recordTypeChange' :dataSource="recordTypesItems"></ejs-dropdownlist>
                            </div>
                        </div>
                        <div class="e-rule-operator e-operator">
                            <ejs-dropdownlist :change='operatorChange' :dataSource="operators" :fields='operatorFields' v-model='ruleOperator'>
                            </ejs-dropdownlist>
                        </div>
                        <div class="e-rule-value e-value" v-if="showInput">
                            <div v-if="showDropDown">
                                <ejs-dropdownlist :allowFiltering="true" :filterType="'Contains'" :ref="'ruleValue'" :dataSource="ddOptions" v-model="ruleValue" :change="optionChange" :fields="optionsFields"></ejs-dropdownlist>
                            </div>
                            <div v-else>
                                <ejs-textbox :ref="'ruleValue'" v-model="ruleValue" :change="optionChange"></ejs-textbox>
                            </div>
                        </div>
                        <div class="e-rule-btn e-rule-value-delete">
                            <button class="e-removerule e-rule-delete e-css e-btn e-small e-round">
                                <span class="e-btn-icon e-icons e-delete-icon"/>
                            </button>
                        </div>
                        <div class="clearfix"></div>
                    </div>`,
            data() {
                return {
                    data: {},
                    outputValue: '',
                    // ddOptions: false,
                    optionsFields: {
                        text: 'text',
                        value: 'value'
                    },
                    operatorFields: {
                        text: 'display',
                        value: 'vueValue'
                    },
                    parent: _this,
                    recordTypesItems: locals.getRecordTypesItems(_this.recordTypesItems)
                };
            },
            created() {
                locals.templateCreated(this, _this);
            },
            computed: {
                dataRule() {
                    return library.cloneObj(this.data.rule, true, true);
                },
                operators() {
                    return locals.getFieldOperators(this);
                },
                isAdditionalParamShown() {
                    let isAdditionalParamShown = false;
                    if (Array.isArray(this.ruleField) && this.ruleField.length) {
                        let tmpField = this.data.columns.find((tmpI) => tmpI['field'] === this.ruleField[0]);
                        isAdditionalParamShown = tmpField?.category === 'org' || tmpField?.category === 'aff' ? tmpField?.category : false;
                        if (!this.parent?.additionalParamItems?.[isAdditionalParamShown]?.length) isAdditionalParamShown = false;
                    }
                    return isAdditionalParamShown;
                },
                ruleAdditionalParam() {
                    return this.dataRule.additionalParam;
                },
                showDropDown() {
                    let showDropDown = false;
                    let showDropDownForOperators = ['equal', 'notequal', 'in', 'notin'];
                    if (this.ddOptions && this.ddOptions.length && showDropDownForOperators.indexOf(this.ruleOperator) !== -1) showDropDown = true;
                    return showDropDown;
                },
                showInput() {
                    let tmpOperator = this.operators.find((tmpI) => tmpI['vueValue'] === this.ruleOperator);
                    return tmpOperator && tmpOperator.input ? tmpOperator.input : false;
                },
                /* fields() {
                    return {
                        dataSource: _this.columns,
                        text: 'label',
                        value: 'field',
                        hasChildren: 'hasChild',
                        parentValue: 'category'
                    };
                }, */
                ruleValue() {
                    return this.dataRule.value;
                },
                ruleField() {
                    if (Array.isArray(this.dataRule.field)) return this.dataRule.field;
                    return [this.dataRule.field];
                },
                ruleCriteriaRecord() {
                    return this.dataRule.criteriaRecord;
                },
                ruleOperator() {
                    return this.dataRule.operator;
                },
                ddOptions() {
                    let currentColumn;
                    if (this.dataRule && this.dataRule.field) {
                        currentColumn = this.data.columns.find((column) => column.field === this.dataRule.field);
                    }
                    if (currentColumn && currentColumn.options) return currentColumn.options;
                    return [];
                }
            },
            methods: {
                ddCreated() {
                    this.$refs['ruleField'].setProperties({ fields: this.$options.fields });
                    this.$refs['ruleField'].setProperties({ value: this.ruleField });
                },
                additionalParamChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    // this.data.rule.additionalParam = args.value;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'additionalParam');
                },
                fieldChange: function (args) {
                    if (!args?.isInteracted) return;
                    args.element = this.$refs['ruleField'].$el;
                    args.value = args.itemData.id;
                    locals.fieldChangeAddInfo(this, args.itemData.id);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'field');
                },
                recordTypeChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    this.data.rule.criteriaRecord = args.value;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'criteriaRecord');
                },
                operatorChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'operator');
                },
                optionChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    if (!args.element) args.element = args.container || false;
                    if (!args.element) args.element = this.$refs['ruleValue'].$el;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'value');
                }
            },
            components: {
                'ejs-dropdownlist': defineAsyncComponent(() => import('@common/syncfusion/dropdownList')),
                'ejs-dropdowntree': defineAsyncComponent(() => import('@common/syncfusion/dropdownTree')),
                'ejs-textbox': defineAsyncComponent(() => import('@common/syncfusion/text')),
            }
        });
        let tmpFunc = locals.templateFunc(tmpCmp, templateId);
        this.listTypeTemplateComponent[_this.cId] = tmpFunc;
        return tmpFunc;
    },
    relativeCriteriaValueComponent: {},
    relativeCriteriaValueTemplate(_this) {
        if (this.relativeCriteriaValueComponent[_this.cId]) return this.relativeCriteriaValueComponent[_this.cId];
        let templateId = 'relativeCriteriaValueTemplate_' + _this.cId + '_' + library.getUniqueID();
        let tmpCmp = vueApp.component(templateId, {
            template: `<div class="e-rule e-rule-template relative-type-template">
                        <div class="e-rule-filter e-custom-filter">
                            <ejs-dropdowntree :created="ddCreated" :showClearButton="false" :allowFiltering="true" :ref="'ruleField'" :filterType="'Contains'" @select='fieldChange' :changeOnBlur="false"></ejs-dropdowntree>
                            <div v-show="isAdditionalParamShown">
                                <ejs-dropdownlist
                                    :placeholder="parent.additionalParamPlaceholders[isAdditionalParamShown]"
                                    :fields="{ text: 'text', value: 'value' }"
                                    v-model="ruleAdditionalParam"
                                    @change='additionalParamChange'
                                    :dataSource="parent.additionalParamItems[isAdditionalParamShown]">
                                </ejs-dropdownlist>
                            </div>
                            <div v-show="!parent.showLogicOnly">
                                <ejs-dropdownlist :placeholder="'Record Type'" :fields="{ text: 'text', value: 'value' }" v-model="ruleCriteriaRecord" @change='recordTypeChange' :dataSource="recordTypesItems"></ejs-dropdownlist>
                            </div>
                        </div>
                        <div>
                            <ejs-dropdowntree :showClearButton="false" v-model="ruleValue.value1" :allowFiltering="true" :filterType="'Contains'" :id="'ruleValue1_' + data.ruleID" :changeOnBlur="false" @change="optionChange"></ejs-dropdowntree>
                            <ejs-textbox v-if="ruleValue.value1.indexOf('parentStoreProp') !== -1" placeholder='Parent Store Prop' :floatLabelType= "'Always'" :id="'ruleValue_value1parentProp_' + data.ruleID" v-model="ruleValue.parentStoreProp1" :change="optionChange"></ejs-textbox>
                        </div>
                        <div class="e-rule-operator e-operator">
                            <ejs-dropdownlist :change='operatorChange' :dataSource="operators" :fields='operatorFields' v-model='ruleOperator'>
                            </ejs-dropdownlist>
                        </div>
                        <div>
                            <ejs-dropdowntree :showClearButton="false" v-model="ruleValue.value2" :allowFiltering="true" :filterType="'Contains'" :id="'ruleValue2_' + data.ruleID" :changeOnBlur="false" @change="optionChange"></ejs-dropdowntree>
                            <ejs-textbox v-if="ruleValue.value2.indexOf('parentStoreProp') !== -1" placeholder='Parent Store Prop' :floatLabelType= "'Always'" :id="'ruleValue_value2parentProp_' + data.ruleID" v-model="ruleValue.parentStoreProp2" :change="optionChange"></ejs-textbox>
                        </div>
                        <div class="e-rule-btn e-rule-value-delete">
                            <button class="e-removerule e-rule-delete e-css e-btn e-small e-round">
                                <span class="e-btn-icon e-icons e-delete-icon"/>
                            </button>
                        </div>
                    </div>`,
            data() {
                return {
                    data: {},
                    outputValue: '',
                    // ddOptions: false,
                    operatorFields: {
                        text: 'display',
                        value: 'vueValue'
                    },
                    parent: _this,
                    recordTypesItems: locals.getRecordTypesItems(_this.recordTypesItems),
                    ruleValue: {
                        value1: [],
                        value2: [],
                        parentStoreProp1: false,
                        parentStoreProp2: false,
                    }
                };
            },
            created() {
                locals.templateCreated(this, _this);
            },
            computed: {
                dataRule() {
                    return library.cloneObj(this.data.rule, true, true);
                },
                operators() {
                    return locals.getFieldOperators(this);
                },
                isAdditionalParamShown() {
                    let isAdditionalParamShown = false;
                    if (Array.isArray(this.ruleField) && this.ruleField.length) {
                        let tmpField = this.data.columns.find((tmpI) => tmpI['field'] === this.ruleField[0]);
                        isAdditionalParamShown = tmpField?.category === 'org' || tmpField?.category === 'aff' ? tmpField?.category : false;
                        if (!this.parent?.additionalParamItems?.[isAdditionalParamShown]?.length) isAdditionalParamShown = false;
                    }
                    return isAdditionalParamShown;
                },
                ruleAdditionalParam() {
                    return this.dataRule.additionalParam;
                },
                /* fields() {
                    return {
                        dataSource: _this.columns,
                        text: 'label',
                        value: 'field',
                        hasChildren: 'hasChild',
                        parentValue: 'category'
                    };
                }, */
                ruleField() {
                    if (Array.isArray(this.dataRule.field)) return this.dataRule.field;
                    return [this.dataRule.field];
                },
                ruleCriteriaRecord() {
                    return this.dataRule.criteriaRecord;
                },
                ruleOperator() {
                    return this.dataRule.operator || 'equal';
                },
            },
            mounted() {
                if (this.dataRule.value !== null && library.isJson(this.dataRule.value)) {
                    this.ruleValue = JSON.parse(this.dataRule.value);
                }
            },
            methods: {
                ddCreated() {
                    this.$refs['ruleField'].setProperties({ fields: this.$options.fields });
                    this.$refs['ruleField'].setProperties({ value: this.ruleField });
                },
                additionalParamChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    // this.data.rule.additionalParam = args.value;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'additionalParam');
                },
                fieldChange: function (args) {
                    if (!args?.isInteracted) return;
                    args.element = this.$refs['ruleField'].$el;
                    args.value = args.itemData.id;
                    locals.fieldChangeAddInfo(this, args.itemData.id);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'field');
                },
                recordTypeChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    this.data.rule.criteriaRecord = args.value;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'criteriaRecord');
                },
                operatorChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'operator');
                },
                optionChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    if (args.event === null) return;
                    let iElem = args.element || args.container;
                    let queryBuilderIDParts = this.data.ruleID.split('_');
                    if (queryBuilderIDParts.length) {
                        let queryBuilderID = queryBuilderIDParts[0] + '_' + queryBuilderIDParts[1];
                        let queryBuilderObj = getComponent(document.getElementById(queryBuilderID), 'query-builder');
                        if (queryBuilderObj) {
                            let ruleValue = library.cloneObj(this.ruleValue);
                            queryBuilderObj.notifyChange(JSON.stringify(ruleValue), iElem, 'value');
                        }
                    }
                }
            },
            components: {
                'ejs-dropdownlist': defineAsyncComponent(() => import('@common/syncfusion/dropdownList')),
                'ejs-dropdowntree': defineAsyncComponent(() => import('@common/syncfusion/dropdownTree')),
                'ejs-textbox': defineAsyncComponent(() => import('@common/syncfusion/text')),
            }
        });
        let tmpFunc = locals.templateFunc(tmpCmp, templateId);
        this.relativeCriteriaValueComponent[_this.cId] = tmpFunc;
        return tmpFunc;
    },
    affiliationValueComponent: {},
    affiliationValueTemplate(_this) {
        if (this.affiliationValueComponent[_this.cId]) return this.affiliationValueComponent[_this.cId];
        let templateId = 'affiliationValueTemplate_' + _this.cId + '_' + library.getUniqueID();
        let tmpCmp = vueApp.component(templateId, {
            template: `<div class="e-rule e-rule-template affiliation-type-template">
                        <div class="e-rule-filter e-custom-filter">
                            <ejs-dropdowntree :created="ddCreated" :allowFiltering="true" :filterType="'Contains'" :ref="'ruleField'"  :changeOnBlur="false" @select='fieldChange'>
                            </ejs-dropdowntree>
                            <div v-show="isAdditionalParamShown">
                                <ejs-dropdownlist
                                    :placeholder="parent.additionalParamPlaceholders[isAdditionalParamShown]"
                                    :fields="{ text: 'text', value: 'value' }"
                                    v-model="ruleAdditionalParam"
                                    @change='additionalParamChange'
                                    :dataSource="parent.additionalParamItems[isAdditionalParamShown]">
                                </ejs-dropdownlist>
                            </div>
                            <div v-show="!parent.showLogicOnly">
                                <ejs-dropdownlist :placeholder="'Record Type'" :fields="{ text: 'text', value: 'value' }" v-model="ruleCriteriaRecord" @change='recordTypeChange' :dataSource="recordTypesItems"></ejs-dropdownlist>
                            </div>
                        </div>
                        <div class="e-rule-value e-value">
                            <ejs-dropdownlist :id="'ruleValue_record1_' + data.ruleID" :dataSource="volOptions"  v-model="ruleValue.value1" :change="optionChange" :fields="optionsFields"></ejs-dropdownlist>
                            <ejs-textbox v-if="ruleValue.value1 === 'fixed_vol' || ruleValue.value1 === 'fixed_opp'" placeholder='Fixed ID' :floatLabelType= "'Always'" :id="'ruleValue_record1Fixedid_' + data.ruleID" :value="ruleValue.value1FixedId" :change="optionChange"></ejs-textbox>
                        </div>
                        <div class="e-rule-operator e-operator" style="display:inline-block; float: none;">
                            <ejs-dropdownlist :change='operatorChange' :dataSource="operators" :fields='operatorFields' v-model='ruleOperator'></ejs-dropdownlist>
                        </div>
                        <div class="e-rule-value e-value">
                            <ejs-dropdownlist :id="'ruleValue_record2_' + data.ruleID" :dataSource="record2SourceOptions"  v-model="ruleValue.value2" :change="optionChange" :fields="optionsFields"></ejs-dropdownlist>
                            <ejs-textbox v-if="ruleValue.value2 === 'fixed_vol' || ruleValue.value2 === 'fixed_opp'" placeholder='Fixed ID' :floatLabelType= "'Always'" :id="'ruleValue_record2Fixedid_' + data.ruleID" :value="ruleValue.value2FixedId" :change="optionChange"></ejs-textbox>
                            <ejs-dropdownlist
                                v-if="data.rule.type === 'affiliation'"
                                placeholder='Status'
                                :floatLabelType= "'Always'"
                                :id="'ruleValue_affstatus_' + data.ruleID"
                                :dataSource="affStatusOptions"
                                :fields="optionsFields"
                                v-model="ruleValue.status"
                                :change="optionChange"
                            ></ejs-dropdownlist>
                        </div>
                        <div class="e-rule-btn e-rule-value-delete">
                            <button class="e-removerule e-rule-delete e-css e-btn e-small e-round">
                                <span class="e-btn-icon e-icons e-delete-icon"/>
                            </button>
                        </div>
                    </div>`,
            data() {
                return {
                    data: {},
                    volOptions: [
                        { text: 'Context Volunteer ID', value: 'context_vol' },
                        { text: 'Source Volunteer ID', value: 'source_vol' },
                        { text: 'Fixed Volunteer', value: 'fixed_vol' },
                    ],
                    oppOptions: [
                        { text: 'Context Opportunity ID', value: 'context_opp' },
                        { text: 'Source Opportunity ID', value: 'source_opp' },
                        { text: 'Fixed Opportunity', value: 'fixed_opp' },
                    ],
                    orgOptions: [
                        { text: 'Context Organization ID', value: 'context_org' },
                        { text: 'Source Organization ID', value: 'source_org' },
                        { text: 'Fixed Organization', value: 'fixed_org' },
                    ],
                    affStatusOptions: [
                        // TODO: Get available status options from ams Config
                        { text: 'Any Status', value: 'any_status' },
                        { text: 'Pending Status', value: 'pending' },
                        { text: 'Active Status', value: 'active' },
                    ],
                    optionsFields: {
                        text: 'text',
                        value: 'value'
                    },
                    operatorFields: {
                        text: 'display',
                        value: 'vueValue'
                    },
                    parent: _this,
                    recordTypesItems: locals.getRecordTypesItems(_this.recordTypesItems),
                    ruleValue: {
                        value1: '',
                        value2: '',
                        value1FixedId: false,
                        value2FixedId: false,
                        status: '',
                        fieldFilter: []
                    }
                };
            },
            created() {
                locals.templateCreated(this, _this);
            },
            computed: {
                dataRule() {
                    return library.cloneObj(this.data.rule, true, true);
                },
                operators() {
                    return locals.getFieldOperators(this);
                },
                isAdditionalParamShown() {
                    let isAdditionalParamShown = false;
                    if (Array.isArray(this.ruleField) && this.ruleField.length) {
                        let tmpField = this.data.columns.find((tmpI) => tmpI['field'] === this.ruleField[0]);
                        isAdditionalParamShown = tmpField?.category === 'org' || tmpField?.category === 'aff' ? tmpField?.category : false;
                        if (!this.parent?.additionalParamItems?.[isAdditionalParamShown]?.length) isAdditionalParamShown = false;
                    }
                    return isAdditionalParamShown;
                },
                ruleAdditionalParam() {
                    return this.dataRule.additionalParam;
                },
                record2SourceOptions() {
                    if (this.dataRule.type === 'affiliation') {
                        return this.orgOptions;
                    }
                    return this.oppOptions;
                },
                /* fields() {
                    return {
                        dataSource: _this.columns,
                        text: 'label',
                        value: 'field',
                        hasChildren: 'hasChild',
                        parentValue: 'category'
                    };
                }, */
                ruleField() {
                    if (Array.isArray(this.dataRule.field)) return this.dataRule.field;
                    return [this.dataRule.field];
                },
                ruleCriteriaRecord() {
                    return this.dataRule.criteriaRecord;
                },
                ruleOperator() {
                    return this.dataRule.operator || 'equal';
                },
                ddOptions() {
                    let currentColumn;
                    if (this.dataRule && this.dataRule.field) {
                        currentColumn = this.data.columns.find((column) => column.field === this.dataRule.field);
                    }
                    if (currentColumn && currentColumn.options) return currentColumn.options;
                    return [];
                }
            },
            mounted() {
                if (this.dataRule.value !== null && library.isJson(this.dataRule.value)) {
                    this.ruleValue = JSON.parse(this.dataRule.value);
                }
            },
            methods: {
                ddCreated() {
                    this.$refs['ruleField'].setProperties({ fields: this.$options.fields });
                    this.$refs['ruleField'].setProperties({ value: this.ruleField });
                },
                additionalParamChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    // this.data.rule.additionalParam = args.value;
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'additionalParam');
                },
                fieldChange: function (args) {
                    if (!args?.isInteracted) return;
                    args.element = this.$refs['ruleField'].$el;
                    args.value = args.itemData.id;
                    locals.fieldChangeAddInfo(this, args.itemData.id);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'field');
                },
                recordTypeChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    this.data.rule.criteriaRecord = args.value;
                    // locals.queryBuilderPropChange(args, this.data.ruleID, 'custom');
                    let queryBuilderIDParts = this.data.ruleID.split('_');
                    if (queryBuilderIDParts.length) {
                        let queryBuilderID = queryBuilderIDParts[0] + '_' + queryBuilderIDParts[1];
                        let queryBuilderObj = getComponent(document.getElementById(queryBuilderID), 'query-builder');
                        if (queryBuilderObj) {
                            let ruleValue = library.cloneObj(this.ruleValue);
                            queryBuilderObj.getRule(args.element).criteriaRecord = args.value;
                            queryBuilderObj.notifyChange(null, args.element, 'value');
                            queryBuilderObj.notifyChange(JSON.stringify(ruleValue), args.element, 'value');
                        }
                    }
                },
                operatorChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    locals.queryBuilderPropChange(args, this.data.ruleID, 'operator');
                },
                optionChange: function (args) {
                    locals.fieldChangeAddInfo(this);
                    let queryBuilderIDParts = this.data.ruleID.split('_');
                    if (queryBuilderIDParts.length) {
                        let queryBuilderID = queryBuilderIDParts[0] + '_' + queryBuilderIDParts[1];
                        let queryBuilderObj = getComponent(document.getElementById(queryBuilderID), 'query-builder');
                        if (queryBuilderObj) {
                            let ruleValue = library.cloneObj(this.ruleValue);
                            this.data.rule.criteriaRecord = this.ruleCriteriaRecord;
                            queryBuilderObj.notifyChange(JSON.stringify(ruleValue), args.element, 'value');
                        }
                    }
                }
            },
            components: {
                'ejs-dropdownlist': defineAsyncComponent(() => import('@common/syncfusion/dropdownList')),
                'ejs-dropdowntree': defineAsyncComponent(() => import('@common/syncfusion/dropdownTree')),
                'ejs-textbox': defineAsyncComponent(() => import('@common/syncfusion/text')),
            }
        });
        let tmpFunc = locals.templateFunc(tmpCmp, templateId);
        this.affiliationValueComponent[_this.cId] = tmpFunc;
        return tmpFunc;
    },
};
const logicEditorCmp = {
    name: 'logicEditor',
    preInitControls: true,
    props: {
        componentId: {
            default: null
        },
        psp: {
            default: false
        },
        object: {
            default: null
        },
        logic: {
            default: []
        },
        logicLoaded: {
            default: false
        },
        otherProps: {
            type: Object,
            default: () => ({})
        },
        validationErrors: {
            default: []
        }
    },
    data() {
        return {
            loading: true,
            columns: [],
            initialValue: null,
            expanded: {},
            activeSubMenus: {},
            queryPreview: false,
            ruleValue: {},
            showItems: false,
            fieldMode: 'DropdownTree',
            itemActions: [
                { text: 'Copy', value: 'copy' },
                { text: 'Move Up', value: 'up' },
                { text: 'Move Down', value: 'down' },
                { text: 'Delete Item', value: 'delete' },
                { text: 'Delete All Items', value: 'deleteAll' },
            ],
            recordTypes: [
                {
                    text: 'Self',
                    value: 'self'
                },
                {
                    text: 'Component',
                    value: 'component'
                }
            ],
            component: null,
            newItem: {
                record: 'self',
                criteriaRecord: 'self',
                additionalParam: 0,
                resultType: 'returnCriteria',
                recordId: '',
                prop: '',
                valueType: '',
                value: '',
                valuePath: '',
                valueAccountSetting: '',
                valueUserSetting: '',
                valueControl: '',
                criteria: ''
            },
            dateOperators: [
                {
                    key: 'Equal', value: 'equal',
                },
                {
                    key: 'Not Equal', value: 'notequal',
                },
                {
                    key: 'Greater Than', value: 'greaterthan',
                },
                {
                    key: 'Greater Than Or Equal', value: 'greaterthanorequal',
                },
                {
                    key: 'Less Than', value: 'lessthan',
                },
                {
                    key: 'Less Than Or Equal', value: 'lessthanorequal',
                },
                {
                    key: 'Between', value: 'amongdate',
                },
                {
                    key: 'Not Between', value: 'notamongdate',
                },
                {
                    key: 'Is Empty', value: 'isempty',
                },
                {
                    key: 'Is Not Empty', value: 'isnotempty',
                }
            ],
            saveTimeout: null,
            additionalParamItems: {},
            additionalParamPlaceholders: {
                'org': 'Assignment Sub-Record',
                'aff': 'Affiliation Type'
            },
            columnsAdded: false,
            fieldsNotFound: false
        };
    },
    computed: {
        fieldsNotFoundWarning() {
            let fieldsNotFoundWarning = this.ddStoreFilter('DD.FILTER.FILTEREDITOR_ERROR_NO_SOME_FIELD');
            if (typeof fieldsNotFoundWarning === 'string' && fieldsNotFoundWarning.indexOf('') !== -1) {
                fieldsNotFoundWarning = fieldsNotFoundWarning.replace('%1!', 'logic');
            }
            return fieldsNotFoundWarning;
        },
        queryBuilderFields() {
            let _this = this;
            return {
                fields: {
                    // dataSource: this.columns,
                    text: 'label',
                    value: 'field',
                    hasChildren: 'hasChild',
                    parentValue: 'category',
                    // child: 'children',
                },
                popupHeight: '400px',
                allowFiltering: true,
                filterType: 'contains',
                filtering: function (event) { event.cancel = false; }, // do not remove,
                created: function () {
                    this.setProperties({ fields: {
                        dataSource: _this.columns,
                        text: 'label',
                        value: 'field',
                        hasChildren: 'hasChild',
                        parentValue: 'category',
                    } });
                    if (typeof USE_NEW_VUE_MODULES === 'undefined' || !USE_NEW_VUE_MODULES) this.setProperties({ value: null });
                },
                select: function (args) {
                    if (!args?.isInteracted) return;
                    let tmpArgs = {
                        element: this.element,
                        isInteracted: true,
                        name: "change",
                        oldValue: null,
                        value: [args.itemData.id]
                    };
                    args.element = this.element;
                    args.value = args.itemData.id;
                    let ruleID = this.customTemplateId.replace('_filterkeyCustomTemplate', '');
                    locals.queryBuilderPropChange(tmpArgs, ruleID, 'changeField');
                }
            };
        },
        valueTypeItems() {
            let items = [
                {
                    text: 'Result of Criteria Evaluation',
                    value: 'criteria'
                },
                {
                    text: 'User Entered Value',
                    value: 'value'
                },
                {
                    text: 'Value From Another Property Path',
                    value: 'path'
                },
                {
                    text: 'Value From Account Settings',
                    value: 'account'
                },
                {
                    text: 'Value From User Settings',
                    value: 'user'
                }
            ];
            if (this.component && typeof this.component.controls !== 'undefined') {
                items.push({
                    text: 'Value From Control',
                    value: 'control'
                });
            }
            return items;
        },
        showLogicOnly() {
            let showLogicOnly = false;
            if (this.otherProps && typeof this.otherProps.showLogicOnly !== 'undefined') {
                showLogicOnly = this.otherProps.showLogicOnly;
            }
            return showLogicOnly;
        },
        recordTypesItems() {
            let output = [];
            if (!this.otherProps || !this.otherProps.hideStandardRecordTypes) {
                for (let i in this.recordTypes) {
                    if (i === 'length') continue;
                    // if (i === '0' && !this.object) continue;
                    output.push(this.recordTypes[i]);
                }
            }
            let otherTypes = this.otherProps.recordTypes;
            if (otherTypes) output = otherTypes.concat(output);
            return output;
        },
        allowedActions() {
            let output = [];
            let actions = this.itemActions;
            let iPermissions = library.getByPath(this.config, 'permissions');
            if (iPermissions) {
                output.push(actions[0]); // copy
                if (iPermissions.move) {
                    output.push(actions[1]); // NOSONAR
                    output.push(actions[2]); // NOSONAR
                }
                if (iPermissions.delete) {
                    output.push(actions[3]);
                    output.push(actions[4]);
                }
            }
            return output;
        },
        enableItemActions() {
            return Array.isArray(this.allowedActions) && this.allowedActions.length;
        },
        accountProperties() {
            return locals.getColumnTypes(['Recruiter Settings', 'Account Settings'], this);
        },
        userProperties() {
            return locals.getColumnTypes(['eC User'], this);
        }
    },
    methods: {
        mouseleave() {
            // logic not saved until unfocus triggered on the value input
            // when the mouse leave logicEditor element (e.g. to click apply), trigger focus leave
            if (
                this.$el.contains(document.activeElement)
                && document.activeElement.tagName === 'INPUT'
                && document.activeElement.id.indexOf('ej2_timepicker') === -1
            ) {
                // unfocus element if it in this logicEditor
                document.activeElement.blur();
            }
        },
        expandItems() {
            this.showItems = !this.showItems;
        },
        disableControls() {
            if (this.otherProps && this.otherProps.showLogicOnly) {
                if (this.$refs && this.$refs['querybuilder' + this.cId] && this.$refs['querybuilder' + this.cId].$el) {
                    this.$refs['querybuilder' + this.cId].$el.querySelectorAll('.e-input.e-control').forEach((input) => {
                        if (input.ej2_instances && input.ej2_instances[0]) {
                            input.ej2_instances[0].enabled = !this.disabled;
                        }
                    });
                    this.$refs['querybuilder' + this.cId].$el.querySelectorAll('.e-removerule').forEach((input) => {
                        if (this.disabled) {
                            input.style.display = 'none';
                        } else {
                            input.style.display = 'block';
                        }
                    });
                }
            } else {
                for (let i in this.logic) {
                    if (i === 'length') continue;
                    if (this.$refs && this.$refs['querybuilder' + i] && this.$refs['querybuilder' + i].length && this.$refs['querybuilder' + i][0].$el) {
                        this.$refs['querybuilder' + i][0].$el.querySelectorAll('.e-input.e-control').forEach((input) => {
                            if (input.ej2_instances && input.ej2_instances[0]) {
                                input.ej2_instances[0].enabled = !this.disabled;
                            }
                        });
                        this.$refs['querybuilder' + i][0].$el.querySelectorAll('.e-removerule').forEach((input) => {
                            if (this.disabled) {
                                input.style.display = 'none';
                            } else {
                                input.style.display = 'block';
                            }
                        });
                    }
                }
            }
        },
        onUpdate() {
            this.disableControls();
        },
        importLogic() {
            let logic = library.cloneObj(this.logic);
            let logicString = JSON.stringify(logic, undefined, 4); // NOSONAR
            let importTemplate = {
                name: "logic-import-template",
                template: `<div><control name="IMPORT_EXPORT_FIELD" :prop-config="importControl" :value="importLogic" @update:value="importLogic = $event"></control><p v-if="!validJson"><strong>Invalid JSON!</strong></p></div>`,
                data() {
                    return {
                        importLogic: logicString,
                        validJson: true,
                        importControl: {
                            name: 'IMPORT_EXPORT_FIELD',
                            type: 'TEXT',
                            label: 'Import/Export',
                            onchange: 'setParentLogic',
                            helpText: 'Use this field to import or export logic rules.',
                            message: 'Copy and paste to import or export.',
                            rows: '15'
                        }
                    };
                },
                methods: {
                    setParentLogic() {
                        logic = this.importLogic;
                        setTimeout(() => {
                            this.validJson = library.isJson(this.importLogic);
                        }, 1000); // NOSONAR
                    }
                },
                components: {
                    control: controlComponent
                }
            };
            let funcPreSuccess = async () => new Promise((resolve) => {
                resolve(library.isJson(logic));
            });
            let funcOnSuccess = () => {
                if (library.isJson(logic)) {
                    this.logic = [];
                    this.logic = JSON.parse(logic);
                    this.onChange();
                } else {
                    library.showToast('Invalid JSON, Your changes were not saved.', { type: 'danger', timeout: 4 });
                }
            };
            library.showDialog(importTemplate, funcOnSuccess, false, { title: 'Import/Export Logic' }, funcPreSuccess);
        },
        setDefaultActiveSubMenus() {
            if (this.showLogicOnly) return;
            let subMenus = library.cloneObj(this.activeSubMenus);
            let logicLen = this.logic.length;
            for (let i = 0; i < logicLen; i++) {
                subMenus[i] = 1;
            }
            this.activeSubMenus = subMenus;
        },
        setActiveSubMenu(index, option) {
            let subMenus = library.cloneObj(this.activeSubMenus);
            subMenus[index] = option;
            this.activeSubMenus = subMenus;
        },
        toggleExpand(index) {
            let expanded = library.cloneObj(this.expanded);
            expanded[index] = expanded[index] !== true;
            this.expanded = expanded;
            let updateInterval = setInterval(() => {
                if (this.columnsAdded) {
                    clearInterval(updateInterval);
                    this.$nextTick(() => {
                        this.updateEditorValue(index);
                    });
                }
            }, 100); // NOSONAR
        },
        showPaths(_event, _button, index) {
            let availablePaths = {};
            let setLogic = () => {
                if (this.logic[index].record === 'self' && this.object) {
                    availablePaths = library.cloneObj(this.object);
                } else if (this.logic[index].record === 'component' && this.component) {
                    let data = {};
                    let props = {};
                    if (this.$store.state.componentStore.componentsConfig[this.component.cType]) {
                        if (typeof this.$store.state.componentStore.componentsConfig[this.component.cType].data === 'function') {
                            data = this.$store.state.componentStore.componentsConfig[this.component.cType].data();
                        }
                        props = this.$store.state.componentStore.componentsConfig[this.component.cType].props;
                    }
                    let config = { config: this.component };
                    availablePaths = { ...data, ...props, ...config };
                }
            };
            if (this.logic && this.logic[index]) {
                setLogic();
            }
            let contentTemplateVue = {
                name: "json-viewer-paths",
                template: `<json-viewer
                    :value="availablePaths"
                    :expand-depth=1
                    copyable
                    boxed
                    sort></json-viewer>`,
                data() {
                    return {
                        availablePaths: availablePaths
                    };
                },
                components: {
                    'json-viewer': JsonViewer
                }
            };
            library.showDialog(contentTemplateVue, false, false, { showAsAlert: true });
        },
        itemSelect(event, index, items) {
            if (event.item.value === 'copy') {
                library.showToast('Item copied!');
                let newItem = library.cloneObj(items[index]);
                items.push(newItem);
                this.logic = items;
            } else if (event.item.value === 'delete') {
                library.showDialog("Are you sure you want to delete this item, and all of it's sub items and properties.", () => {
                    items.splice(index, 1);
                    this.logic = items;
                });
            } else if (event.item.value === 'deleteAll') {
                library.showDialog("Are you sure you want to delete all items, and all of it's sub items and properties.", () => {
                    items.splice(0, items.length);
                    this.logic = items;
                });
            } else if (event.item.value === 'up') {
                if (index - 1 >= 0) {
                    this.logic = library.moveArrayItem(this.logic, index, index - 1);
                }
            } else if (event.item.value === 'down' && (index + 1 < this.logic.length)) {
                this.logic = library.moveArrayItem(this.logic, index, index + 1);
            }
        },
        addItem() {
            let tmp = library.cloneObj(this.logic);
            tmp.push(this.newItem);
            this.showItems = true;
            this.logic = tmp;
        },
        // allowFiltering crutch for the filter columns
        allowFilterFiltering() {
            this.$nextTick(() => {
                for (let i in this.logic) {
                    if (i === 'length') continue;
                    if (this.$refs && this.$refs['querybuilder' + i] && this.$refs['querybuilder' + i].length && this.$refs['querybuilder' + i][0].$el) {
                        // each filter dropdown in query builder
                        this.$refs['querybuilder' + i][0].$el.querySelectorAll('.e-filter-input.e-control.e-dropdownlist').forEach((filterDropdown) => {
                            // set up allowFiltering property
                            if (filterDropdown.ej2_instances && filterDropdown.ej2_instances[0]) {
                                filterDropdown.ej2_instances[0].allowFiltering = true;
                                filterDropdown.ej2_instances[0].filterType = 'contains';
                            }
                        });
                    }
                }
                this.disableControls();
            });
        },
        onChange(event) {
            if (this.loading) return;
            if (this.saveTimeout) {
                clearTimeout(this.saveTimeout);
            }
            this.saveTimeout = setTimeout(() => {
                this.save();
            }, 200); // NOSONAR
            setTimeout(() => {
                this.disableControls();
            }, 500); // NOSONAR
            // this.allowFilterFiltering();
        },
        async onLoad() {
            this.initialValue = this.logic;
            if (!Array.isArray(this.logic)) {
                if (typeof this.logic === 'object') this.logic = [this.logic];
                else this.logic = [];
            }
            if (this.otherProps && this.otherProps.convertLogic) {
                let fieldsPsp = this.otherProps && this.otherProps.fieldsPsp;
                if (this.psp) {
                    let logicPossiblePspList = await configStore.getLogicPossiblePspList(this.psp);
                    fieldsPsp = library.cloneObj(logicPossiblePspList);
                }
                await library.prepLogicParsingToFront(fieldsPsp);
            }
            let tmpKinds = await configStore.getAttrList(['org_kind']);
            let tmpAdditionalParamItems = { org: [], aff: [] };
            this.additionalParamItems = {};
            for (let i in tmpKinds) {
                tmpAdditionalParamItems['org'].push({
                    text: tmpKinds[i],
                    value: i
                });
            }
            tmpAdditionalParamItems['org'].push({
                text: 'Detail Record',
                value: '9999'
            });
            if (this.additionalParamItems) {
                tmpAdditionalParamItems['aff'] = [
                    { text: 'Volunteer to Organization Affiliation', value: '0' },
                    { text: 'Volunteer Assignment', value: '1' },
                    { text: 'Volunteer to Activity Affiliation', value: '2', default: true },
                    { text: 'Organization to Organization Affiliation', value: '3' },
                ];
                for (let pspId in this?.otherProps?.excludeAdditionalParams) {
                    /*
                    additional params are disabled for the enabled/completed logic:
                    AFF_IS_ENABLED/AFF_IS_COMPLETED should have only 2 states (true/false) and should not be based on organization/assignment logic,
                    otherwise DB will have corruped data, because the same affiliation can be presents in different assignments
                    * */
                    tmpAdditionalParamItems[pspId] = tmpAdditionalParamItems[pspId].filter((tmpItem) => !(this?.otherProps?.excludeAdditionalParams[pspId] === 'all'
                           || (
                               Array.isArray(this?.otherProps?.excludeAdditionalParams[pspId])
                               && this?.otherProps?.excludeAdditionalParams[pspId].indexOf(tmpItem.value) !== -1
                           )));
                }
                this.additionalParamItems = library.cloneObj(tmpAdditionalParamItems);
                this.setDefaultActiveSubMenus();
                this.onPropsUpdate();
            }
        },
        async updateEditorValue(index, fromPropsUpdate) {
            let tmpRef = this.otherProps && this.otherProps.showLogicOnly ? 'querybuilder' + this.cId : 'querybuilder' + index;
            let builderRef = this.$refs
                && this.$refs[tmpRef]
                && this.$refs[tmpRef].length
                && this.$refs[tmpRef][0].ej2Instances;
            if (typeof builderRef === 'undefined' && this.otherProps && this.otherProps.showLogicOnly) {
                builderRef = this.$refs
                    && this.$refs[tmpRef]
                    && this.$refs[tmpRef].ej2Instances;
            }
            if (builderRef) {
                builderRef.getRuleCollection = locals.getRuleCollection;
            }
            let tmpRules = this.otherProps && this.otherProps.showLogicOnly ? this.propLogic : this.logic[index].criteria;
            if (this.otherProps && this.otherProps.convertLogic && typeof tmpRules === 'string') {
                if (library.objIsEmpty(tmpRules)) return;
                tmpRules = library.parseLogicToFront(tmpRules, false, true);
                if (library.isEqualObj(tmpRules, this.prevRules)) return;
                this.prevRules = tmpRules;
            }
            let refLoadInterval = setInterval(() => {
                let builderRef = this.$refs
                    && this.$refs[tmpRef]
                    && this.$refs[tmpRef].length
                    && this.$refs[tmpRef][0].ej2Instances;
                if (typeof builderRef === 'undefined' && this.otherProps && this.otherProps.showLogicOnly) {
                    builderRef = this.$refs
                        && this.$refs[tmpRef]
                        && this.$refs[tmpRef].ej2Instances;
                }
                if (builderRef) {
                    clearInterval(refLoadInterval);
                    this.$nextTick(() => {
                        builderRef.getRuleCollection = locals.getRuleCollection;
                        if (!builderRef.columns.length) {
                            // apply only once
                            builderRef.setProperties({ columns: this.columns });
                        }
                        if (!library.objIsEmpty(tmpRules)) {
                            let availableFieldsNames = [];
                            if (Array.isArray(this.columns)) this.columns.forEach((tmp) => { availableFieldsNames.push(tmp.field); });
                            let currentLogicFields = [];
                            if (typeof tmpRules === 'object') {
                                let flattenTmpRules = library.flatten(tmpRules);
                                for (let ftrI in flattenTmpRules) {
                                    if ((ftrI + '').endsWith('.field') && flattenTmpRules[ftrI] !== '__field__') currentLogicFields.push(flattenTmpRules[ftrI]);
                                }
                            }
                            if (!library.arrayIncludesAll(availableFieldsNames, currentLogicFields)) {
                                this.fieldsNotFound = true;
                            } else {
                                this.fieldsNotFound = false;
                                builderRef.setRules(tmpRules);
                                this.$nextTick(() => {
                                    if (!fromPropsUpdate) this.onChange();
                                });
                            }
                        }
                    });
                }
            }, 50);
        },
        async addColumns() {
            if (this.columnsAdding || this.columnsAdded) return;
            this.columnsAdding = true;
            if (!Array.isArray(this.logic)) this.logic = [];
            let tmpLogic = [];
            for (let i in this.logic) {
                if (i === 'length') continue;
                tmpLogic[i] = library.cloneObj(this.newItem);
                for (let j in this.logic[i]) {
                    if (j === 'length') continue;
                    tmpLogic[i][j] = library.cloneObj(this.logic[i][j]);
                }
            }
            this.logic = tmpLogic;
            let tmpOperators = await configStore.getLogicOperatorsList();
            tmpOperators = library.cloneObj(tmpOperators, true, true);
            let realOperators = {};
            for (let i in tmpOperators) {
                for (let j in tmpOperators[i]) {
                    if (typeof tmpOperators[i][j]["vueValue"] === 'undefined') {
                        continue;
                    }
                    if (typeof tmpOperators[i][j]["isSubOper"] !== 'undefined') {
                        if (typeof realOperators[i + "SubOperators"] === 'undefined') realOperators[i + "SubOperators"] = [];
                        realOperators[i + "SubOperators"].push(tmpOperators[i][j]);
                    } else {
                        if (typeof realOperators[i] === 'undefined') realOperators[i] = [];
                        realOperators[i].push(tmpOperators[i][j]);
                    }
                }
            }
            realOperators.context = [
                { display: 'equals', input: 1, oper: '=', operandID: 1, vueValue: 'equal' },
                { display: 'does not equal', input: 1, oper: '!=', operandID: 2, vueValue: 'notequal' },
                { display: 'is empty', oper: 'is', operandID: 8, vueValue: 'isempty' },
                { display: 'is not empty', oper: 'is not', operandID: 9, vueValue: 'isnotempty' },
            ];
            realOperators.affiliation = [
                { display: 'Affiliated with', input: 1, vueValue: 'in' },
                { display: 'Not Affiliated with', input: 1, vueValue: 'notin' },
                { display: 'No Affiliations', oper: 'is', operandID: 8, vueValue: 'isempty' },
                { display: 'Any Affiliation', oper: 'is not', operandID: 9, vueValue: 'isnotempty' }
            ];
            realOperators.refPlace = [
                { display: 'Referred with', input: 1, vueValue: 'referred' },
                { display: 'Placed with', input: 1, vueValue: 'placed' },
                { display: 'Not Referred with', input: 1, vueValue: 'notreferred' },
                { display: 'Not Placed with', input: 1, vueValue: 'notplaced' },
                { display: 'No Referrals', oper: 'is', operandID: 8, vueValue: 'isemptyreferred' },
                { display: 'Any Referrals', oper: 'is not', operandID: 9, vueValue: 'isanyreferred' },
                { display: 'No Placements', oper: 'is', operandID: 8, vueValue: 'isemptyplaced' },
                { display: 'Any Placements', oper: 'is not', operandID: 9, vueValue: 'isanyplaced' }
            ];
            realOperators.relativeCriteria = [
                { display: 'includes', input: 1, oper: 'like', operandID: 1, vueValue: 'in' },
                { display: 'does not include', input: 1, oper: 'not like', operandID: 2, vueValue: 'notin' },
            ];
            realOperators.empty = [
                { display: 'equals', input: 1, oper: '=', operandID: 1, vueValue: 'equal' },
            ];
            realOperators = library.cloneObj(realOperators, true, true);
            this.operators = realOperators;
            let tmpColumns = [
                {
                    field: 'Data',
                    label: 'Data',
                    type: 'string',
                    hasChild: true,
                    selectable: false,
                    htmlAttributes: { 'prevent-select': 'true' },
                },
                {
                    field: 'Props',
                    label: 'Props',
                    type: 'string',
                    hasChild: true,
                    selectable: false,
                    htmlAttributes: { 'prevent-select': 'true' },
                },
                {
                    field: 'Current Instance',
                    label: 'Current Instance',
                    type: 'string',
                    hasChild: true,
                    selectable: false,
                    htmlAttributes: { 'prevent-select': 'true' },
                },
                {
                    field: 'Controls',
                    label: 'Controls',
                    type: 'string',
                    hasChild: true,
                    selectable: false,
                    htmlAttributes: { 'prevent-select': 'true' },
                },
                {
                    field: 'Store Props',
                    label: 'Store Props',
                    type: 'string',
                    hasChild: true,
                    selectable: false,
                    htmlAttributes: { 'prevent-select': 'true' },
                },
                {
                    field: 'Fields',
                    label: 'Fields',
                    type: 'string',
                    hasChild: true,
                    selectable: false,
                    htmlAttributes: { 'prevent-select': 'true' },
                    expanded: this.otherProps && this.otherProps.convertLogic
                },
                {
                    field: 'Account Settings',
                    label: 'Account Settings',
                    type: 'string',
                    hasChild: true,
                    selectable: false,
                    htmlAttributes: { 'prevent-select': 'true' },
                },
                {
                    field: 'Recruiter Settings',
                    label: 'Recruiter Settings',
                    type: 'string',
                    hasChild: true,
                    selectable: false,
                    htmlAttributes: { 'prevent-select': 'true' },
                },
                {
                    field: 'eC User',
                    label: 'eC User',
                    type: 'string',
                    hasChild: true,
                    selectable: false,
                    htmlAttributes: { 'prevent-select': 'true' },
                },
                {
                    field: 'Relative',
                    label: 'Relative',
                    type: 'string',
                    hasChild: true,
                    selectable: false,
                    htmlAttributes: { 'prevent-select': 'true' },
                },
                {
                    field: 'Affiliation',
                    label: 'Affiliation',
                    type: 'affiliation',
                    operators: realOperators.affiliationOperators,
                    ruleTemplate: criteriaTemplates.affiliationValueTemplate(this),
                },
                {
                    field: 'refPlace',
                    label: 'Referral Placement',
                    type: 'refPlace',
                    operators: realOperators.refPlaceOperators,
                    ruleTemplate: criteriaTemplates.affiliationValueTemplate(this),
                }
            ];
            this.columns = [];
            let setParentOption = (column) => {
                if (!tmpColumns.find((jColumn) => jColumn.field === column.category)) {
                    tmpColumns.push({
                        field: column.category,
                        label: column.category,
                        type: 'string',
                        hasChild: true
                    });
                }
            };
            if (this.otherProps) {
                if (this.otherProps.allowedColumns) {
                    let tmpAllowedColumns = [];
                    for (let i in tmpColumns) {
                        if (this.otherProps.allowedColumns.indexOf(tmpColumns[i].field) !== -1) {
                            tmpAllowedColumns.push(library.cloneObj(tmpColumns[i]));
                        }
                    }
                    if (tmpAllowedColumns.length) {
                        tmpColumns = library.cloneObj(tmpAllowedColumns);
                    }
                }
                if (this.otherProps.defaultRecordType) {
                    this.newItem.record = this.otherProps.defaultRecordType;
                    this.newItem.criteriaRecord = this.otherProps.defaultRecordType;
                }
                if (this.otherProps.otherColumns) {
                    let otherColumns = library.cloneObj(this.otherProps.otherColumns);
                    let mappedColumns = otherColumns.map((iColumn) => {
                        setParentOption(iColumn);
                        iColumn.operators = this[iColumn.operators];
                        return iColumn;
                    });
                    tmpColumns = tmpColumns.concat(mappedColumns);
                }
            }
            let setupCurrentInstance = async () => {
                let props = await configStore.getCurrentInstanceDetails();
                for (let i in props) {
                    if (i === 'length') continue;
                    let type = props[i].type;
                    type = library.logicMappedType(type);
                    let newColumn = {
                        field: 'this.component.currentInstance.' + i,
                        label: "Current Instance: " + (props[i].label || i),
                        type: type,
                        category: 'Current Instance',
                        operators: realOperators[type]
                    };
                    if (typeof criteriaTemplates[type + 'TypeTemplate'] === "function") {
                        newColumn.ruleTemplate = criteriaTemplates[type + 'TypeTemplate'](this);
                    } else {
                        newColumn.ruleTemplate = criteriaTemplates.defaultFieldTemplate(this);
                    }
                    tmpColumns.push(newColumn);
                }
            };
            let setupProps = (initialConfig) => {
                let props = initialConfig.props;
                for (let i in props) {
                    if (i === 'length') continue;
                    let type = 'string';
                    if (typeof props[i].type === 'function' && props[i].type.name) {
                        type = props[i].type.name.toLowerCase();
                    }
                    type = library.logicMappedType(type);
                    let newColumn = {
                        field: i,
                        label: "Prop: " + i,
                        type: type,
                        category: 'Props',
                        operators: realOperators[type]
                    };
                    if (typeof criteriaTemplates[type + 'TypeTemplate'] === "function") {
                        newColumn.ruleTemplate = criteriaTemplates[type + 'TypeTemplate'](this);
                    } else {
                        newColumn.ruleTemplate = criteriaTemplates.defaultFieldTemplate(this);
                    }
                    tmpColumns.push(newColumn);
                }
            };
            let setupData = (initialConfig) => {
                if (typeof initialConfig.data === 'function') {
                    let dataTypes = initialConfig.dataTypes;
                    let data = initialConfig.data();
                    for (let i in data) {
                        if (i === 'length') continue;
                        let type = typeof data[i] || 'string';
                        if (dataTypes && dataTypes[i]) type = dataTypes[i];
                        else if (library.isDate(data[i])) type = 'date';
                        else if (type === 'object' && Array.isArray(data[i])) type = 'array';
                        type = library.logicMappedType(type);
                        let newColumn = {
                            field: i,
                            label: "Data: " + i,
                            type: type,
                            category: 'Data',
                            operators: realOperators[type]
                        };
                        if (typeof criteriaTemplates[type + 'TypeTemplate'] === "function") {
                            newColumn.ruleTemplate = criteriaTemplates[type + 'TypeTemplate'](this);
                        } else {
                            newColumn.ruleTemplate = criteriaTemplates.defaultFieldTemplate(this);
                        }
                        tmpColumns.push(newColumn);
                    }
                }
            };
            let setupConfig = async () => {
                let config = await componentStore.getConfig(this.componentId);
                this.component = library.cloneObj(config);
                if (!config) return;
                let initialConfigs = componentStore.get('componentsConfig');
                if (config.cType && initialConfigs[config.cType]) {
                    setupCurrentInstance();
                    setupProps(initialConfigs[config.cType]);
                    setupData(initialConfigs[config.cType]);
                }

                let excludedTypes = ['array', 'list', 'button', 'dropdownbutton'];
                for (let i in config.controls) {
                    if (i === 'length') continue;
                    if (excludedTypes.indexOf(config.controls[i].type) !== -1) continue;
                    let type = library.logicMappedType(config.controls[i].type);
                    let newColumn = {
                        field: "this.controls['" + config.controls[i].name + "'].value",
                        label: "Controls: " + config.controls[i].label || config.controls[i].placeholder || config.controls[i].name,
                        type: type,
                        category: 'Controls',
                        operators: realOperators[type]
                    };
                    if (config.controls[i].items) {
                        let textKey = config.controls[i].fields ? config.controls[i].fields.text : 'text';
                        let valueKey = config.controls[i].fields ? config.controls[i].fields.value : 'value';
                        newColumn.options = config.controls[i].items.map((option) => (
                            {
                                text: option[textKey] || option.text || option.label || option,
                                value: option[valueKey] || option.value || option.label || option
                            }
                        ));
                        newColumn.ruleTemplate = criteriaTemplates.listTypeTemplate(this);
                    } else {
                        if (typeof criteriaTemplates[type + 'TypeTemplate'] === "function") {
                            newColumn.ruleTemplate = criteriaTemplates[type + 'TypeTemplate'](this);
                        } else {
                            newColumn.ruleTemplate = criteriaTemplates.defaultFieldTemplate(this);
                        }
                    }
                    tmpColumns.push(newColumn);
                }
                if (config.cType === 'layoutContainer') {
                    for (let i in config.storeProps) {
                        if (i === 'length') continue;
                        let type = library.logicMappedType(config.storeProps[i].type);
                        let newColumn = {
                            field: 'Store Prop:' + config.storeProps[i].property,
                            label: 'Store Props: ' + config.storeProps[i].property,
                            type: type,
                            category: 'Store Props',
                            operators: realOperators[type],
                        };
                        if (typeof criteriaTemplates[type + 'TypeTemplate'] === "function") {
                            newColumn.ruleTemplate = criteriaTemplates[type + 'TypeTemplate'](this);
                        } else {
                            newColumn.ruleTemplate = criteriaTemplates.defaultFieldTemplate(this);
                        }
                        tmpColumns.push(newColumn);
                    }
                }
                if (!this.otherProps || (this.otherProps && !this.otherProps.showLogicOnly)) {
                    let contextRecordProps = ['volId', 'oppId', 'orgId', 'lbeId'];
                    tmpColumns.push({
                        field: 'Context',
                        label: 'Contextual Record',
                        type: 'string',
                        hasChild: true
                    });
                    contextRecordProps.forEach((rProp) => {
                        tmpColumns.push({
                            field: rProp,
                            label: 'Contextual Record: ' + rProp,
                            type: 'numeric',
                            category: 'Context',
                            operators: realOperators['context'], // subset of numeric
                            ruleTemplate: criteriaTemplates.numericTypeTemplate(this)
                        });
                    });
                }
            };
            let setupFields = async () => {
                let configStoreData = {};
                let phoneMask = '(000) 000-0000 0';
                if (tmpColumns.find((jColumn) => jColumn.field === 'Account Settings')) {
                    configStoreData['accountSettings'] = await configStore.getAccountSettings();
                }
                if (tmpColumns.find((jColumn) => jColumn.field === 'Recruiter Settings')) {
                    configStoreData['recruiterSettings'] = await configStore.getRecruiterSettings();
                }
                if (tmpColumns.find((jColumn) => jColumn.field === 'eC User')) {
                    configStoreData['ecUserProperty'] = await uStore().getUserData();
                }
                if (tmpColumns.find((jColumn) => jColumn.field === 'Fields')) {
                    let accountSettings = await configStore.getAccountSettings();
                    if (accountSettings['ACCOUNT_PHONE_FORMAT']) {
                        phoneMask = accountSettings['ACCOUNT_PHONE_FORMAT'].replaceAll('%s', '0');
                    } else {
                        phoneMask = false;
                    }
                    let fieldsPsp = this.otherProps && this.otherProps.fieldsPsp;
                    if (this.psp) {
                        let logicPossiblePspList = await configStore.getLogicPossiblePspList(this.psp);
                        fieldsPsp = library.cloneObj(logicPossiblePspList);
                    }
                    configStoreData['availableFields'] = await configStore.allLogicClausesOptions(fieldsPsp);
                }
                // if (tmpColumns.find((jColumn) => jColumn.field === 'Affiliation')) {
                //     configStoreData['affiliationList'] = await configStore.affiliationOptions();
                // }
                // TODO redo filtering
                let setColumnFromAvailableFields = (fieldOption) => {
                    let excludeFieldsPsp = this.otherProps && this.otherProps.excludeFieldsPsp;
                    if (fieldOption.pId) {
                        let optionData = fieldOption.optionData;
                        let type = optionData && optionData.LOGIC && optionData.LOGIC.clauseType ? optionData.LOGIC.clauseType : 'string';
                        if (typeof realOperators[type] === 'undefined') return;
                        // if (type === 'string' && (optionData.MULTI_VALUE || (optionData.LIST_VALUES && optionData.LIST_VALUES.length))) type = 'list';
                        type = library.logicMappedType(type);
                        let fieldName = fieldOption.value;
                        if (fieldOption.pId === 'lbe' || fieldOption.pId === 'waiver' || fieldOption.pId === 'training') {
                            fieldName = fieldOption.value;
                        }

                        let newColumn = {
                            field: fieldName,
                            label: this.otherProps && this.otherProps.showLogicOnly ? fieldOption.text : "Fields: " + fieldOption.text,
                            type: type,
                            category: fieldOption.pId,
                            operators: realOperators[type]
                        };
                        if (optionData && optionData.LOGIC && optionData.LOGIC && Array.isArray(optionData.LOGIC.operands)) {
                            newColumn['filterOperators'] = optionData.LOGIC.operands;
                        }
                        if (optionData && optionData.IS_PHONE && phoneMask) {
                            newColumn.IS_PHONE = true;
                            newColumn.mask = phoneMask;
                        }
                        if (optionData && optionData.IS_EMAIL) {
                            newColumn.IS_EMAIL = true;
                        }
                        if (optionData && optionData.LIST_VALUES && optionData.LIST_VALUES.length) {
                            let isNumeric = library.logicMappedType(optionData?.LOGIC?.clauseType) === 'numeric';
                            let valField = isNumeric && optionData?.LIST_VALUES?.[0]?.id ? 'id' : 'label';
                            let fields = optionData?.LOGIC?.fields || { value: valField, label: 'label' };
                            newColumn.options = optionData.LIST_VALUES.map((option) => ({ text: option[fields.label], value: isNumeric ? parseInt(option[fields.value], 10) : option[fields.value].toString() }));
                            newColumn.ruleTemplate = criteriaTemplates.listTypeTemplate(this);
                        } else {
                            if (type === 'date_period') type = 'datePeriod';
                            if (typeof criteriaTemplates[type + 'TypeTemplate'] === "function") {
                                newColumn.ruleTemplate = criteriaTemplates[type + 'TypeTemplate'](this);
                            } else {
                                newColumn.ruleTemplate = criteriaTemplates.defaultFieldTemplate(this);
                            }
                        }
                        if (!newColumn.ruleTemplate) {
                            newColumn.ruleTemplate = criteriaTemplates.defaultFieldTemplate(this);
                        }
                        if (Array.isArray(excludeFieldsPsp) && excludeFieldsPsp.indexOf(fieldOption.psp) !== -1) newColumn.selectable = false;
                        tmpColumns.push(newColumn);
                    } else {
                        // Add parent (non-selectable) dropdown items
                        let newColumn = {
                            field: fieldOption.value,
                            label: fieldOption.text,
                            type: 'string',
                            category: "Fields",
                            hasChild: true,
                            selectable: false,
                            htmlAttributes: { 'prevent-select': 'true' },
                        };
                        if (Array.isArray(excludeFieldsPsp) && excludeFieldsPsp.indexOf(fieldOption.value) !== -1) newColumn.label += ' (clauses disabled, will be removed soon)';
                        tmpColumns.push(newColumn);
                    }
                };
                // let setAffilColumns = (fieldOption) => {
                //     let type = 'affiliaton';
                //     let newColumn = {
                //         field: fieldOption.value,
                //         label: "Affiliation: " + fieldOption.text,
                //         type: type,
                //         category: fieldOption.pId,
                //         operators: this[type + 'Operators'],
                //         ruleTemplate: criteriaTemplates.affiliationValueTemplate(this),
                //     };
                //     tmpColumns.push(newColumn);
                // };
                for (let i in configStoreData) {
                    if (i === 'length') continue;
                    if (!configStoreData[i]) continue;
                    // Fields configuration happens here
                    if (i === 'availableFields') {
                        configStoreData[i].forEach((fieldOption) => {
                            setColumnFromAvailableFields(fieldOption);
                        });
                        let type = 'array';
                        if (configStore.state && configStore.state.cfg && configStore.state.cfg.attrList && configStore.state.cfg.attrList.aff_status_2) {
                            let newColumn = {
                                field: 'aff:::AFF_STATUS',
                                label: this.otherProps && this.otherProps.showLogicOnly ? "Affiliation Status" : "Fields: Affiliation Status",
                                type: type,
                                category: 'aff',
                                operators: realOperators[type]
                            };
                            newColumn.options = [];
                            for (let tmpI in configStore.state.cfg.attrList.aff_status_2) {
                                newColumn.options.push({
                                    text: configStore.state.cfg.attrList.aff_status_2[tmpI],
                                    value: tmpI
                                });
                            }
                            newColumn.ruleTemplate = criteriaTemplates.listTypeTemplate(this);
                            tmpColumns.push(newColumn);
                        }
                    } else {
                        // else if (i === 'affiliationList') {
                        //     // configStoreData[i].forEach((fieldOption) => {
                        //     //     setAffilColumns(fieldOption);
                        //     // });
                        // }
                        let category = '';
                        let prefix = '';
                        let field = i;
                        switch (i) {
                            case 'accountSettings':
                                prefix = 'Account Settings: ';
                                category = 'Account Settings';
                                break;
                            case 'recruiterSettings':
                                prefix = 'Recruiter Settings: ';
                                category = 'Recruiter Settings';
                                break;
                            case 'ecUserProperty':
                                prefix = 'eC User: ';
                                category = 'eC User';
                                field = 'user';
                                break;
                        }
                        for (let j in configStoreData[i]) {
                            if (j === 'length') continue;
                            let newColumn;
                            if (j === 'availableActivities') {
                                newColumn = {
                                    field: "this." + field + "." + j,
                                    label: prefix + 'Available Activities',
                                    type: 'array',
                                    ruleTemplate: criteriaTemplates.listTypeTemplate(this),
                                    category: category,
                                    operators: realOperators['array']
                                };
                                newColumn.options = [];
                                for (let tmpI in configStoreData[i][j]) {
                                    let aOpt = configStoreData[i][j][tmpI];
                                    if (typeof aOpt !== 'object') continue;
                                    newColumn.options.push({
                                        text: aOpt.AE_TITLE,
                                        value: aOpt.ACTIVITY_ENTITY_ID
                                    });
                                }
                                tmpColumns.push(newColumn);
                            } else {
                                newColumn = {
                                    field: "this." + field + "." + j,
                                    label: prefix + j,
                                    type: 'string',
                                    ruleTemplate: criteriaTemplates.stringTypeTemplate(this),
                                    category: category,
                                    operators: realOperators['string']
                                };
                                tmpColumns.push(newColumn);
                            }
                        }
                    }
                }
                tmpColumns.push({
                    field: 'relativeCriteriaValue',
                    label: 'Relative Compare Value',
                    type: 'relativeCriteria',
                    category: 'Relative',
                    ruleTemplate: criteriaTemplates.relativeCriteriaValueTemplate(this),
                    operators: realOperators['relativeCriteria']
                });
                tmpColumns.sort((a, b) => {
                    let ta = (a.label).toLowerCase();
                    let tb = (b.label).toLowerCase();
                    if (ta < tb) return -1;
                    if (ta > tb) return 1;
                    return 0;
                });
            };
            this.loading = true;
            library.showLoadingIndicator(this.cId);
            if (this.componentId || (this.otherProps && this.otherProps.showLogicOnly)) {
                await setupConfig();
            }
            await setupFields();
            this.columns = library.cloneObj(tmpColumns, true, true);
            library.hideLoadingIndicator(this.cId);
            this.columnsAdded = true;
            this.columnsAdding = false;
            this.loading = false;
            this.$emit('update:propLogicLoaded', true);
        },
        onPropsUpdate() {
            if (!this?.columnsAdded) this.addColumns();
            if (this.otherProps && this.otherProps.showLogicOnly) {
                this.updateEditorValue(false, true);
            }
        },
        async manualSave() {
            if (this.disabled) return;
            let query = await this.getLogic();
            if (!library.isEqualObj(this.propLogic, query)) {
                this.$emit('update:propLogic', query);
            }
        },
        async save(force) {
            if (this.disabled) return;
            if (!force && this.otherProps && this.otherProps.manualSave) return;
            if (this.otherProps
                && this.otherProps.showLogicOnly
                && this.otherProps.convertLogic
                && typeof this?.$refs?.['querybuilder' + this.cId]?.ej2Instances?.getRules === 'function') {
                // do not save logic untill all rules will be completed
                let isCompletedLogic = () => {
                    let validRules = this.$refs['querybuilder' + this.cId].ej2Instances.getValidRules();
                    let allRules = this.$refs['querybuilder' + this.cId].ej2Instances.getRules();
                    let flattenValidRules = library.flatten(validRules);
                    let flattenAllRules = library.flatten(allRules);
                    let emptyLogic = {
                        condition: "and",
                        rules: []
                    };
                    let isEmptyLogic = library.isEqualObj(emptyLogic, flattenAllRules);
                    for (let i in flattenValidRules) {
                        if (i.indexOf('.additionalParam') !== -1) {
                            // remove additionalParams from compare if not set
                            if (!(typeof flattenValidRules[i] === 'string' && flattenValidRules[i])) delete flattenValidRules[i];
                        }
                        if (i.indexOf('.criteriaRecord') !== -1) delete flattenValidRules[i];
                        if (i.indexOf('.value') !== -1 && !flattenValidRules[i]) {
                            let currentLevel = i.replace(new RegExp('.value$'), '');
                            let ruleOperator = flattenAllRules[currentLevel + '.operator'];
                            let ruleType = flattenAllRules[currentLevel + '.type'];
                            if (this.operators[ruleType]) {
                                let tmpOperator = this.operators[ruleType].find((tmp) => tmp.vueValue === ruleOperator);
                                if (tmpOperator && tmpOperator.input) {
                                    delete flattenValidRules[i];
                                }
                            }
                        }
                    }
                    for (let i in flattenAllRules) {
                        if (i.indexOf('.additionalParam') !== -1) {
                            // remove additionalParams from compare if not set
                            if (!(typeof flattenAllRules[i] === 'string' && flattenAllRules[i])) delete flattenAllRules[i];
                        }
                        if (i.indexOf('.criteriaRecord') !== -1) delete flattenAllRules[i];
                        if (i.indexOf('.value') !== -1) {
                            let currentLevel = i.replace(new RegExp('.value$'), '');
                            let ruleOperator = flattenAllRules[currentLevel + '.operator'];
                            if (typeof ruleOperator?.endsWith === 'function' && ruleOperator.endsWith('_array')) ruleOperator = ruleOperator.replace('_array', '');
                            // if it is empty or not empty the getRules return value = "", when the getValidRules return value = null
                            // in these cases we should make values equals, otherwise validRules and allRules will be different and the logic is not saving
                            if ((ruleOperator === 'isempty' || ruleOperator === 'isnotempty')) {
                                flattenAllRules[i] = flattenValidRules[i];
                            }
                        }
                    }
                    return library.isEqualObj(flattenValidRules, flattenAllRules) || isEmptyLogic;
                };
                let toggleAddButtons = (disable) => {
                    let addBtns = this.$el.querySelectorAll('.e-add-btn');
                    for (let i in addBtns) {
                        if (!addBtns.hasOwnProperty(i)) continue;
                        addBtns[i].disabled = disable;
                    }
                };
                if (!isCompletedLogic()) {
                    toggleAddButtons(true);
                    return;
                }
                toggleAddButtons(false);
            }
            let query = await this.getLogic();
            if (!library.isEqualObj(this.propLogic, query)) {
                this.$emit('update:propLogic', query);
            }
        },
        async getLogic() {
            let result = [];
            if (this.otherProps && this.otherProps.showLogicOnly) {
                result = {};
                if (
                    this.$refs
                    && this.$refs['querybuilder' + this.cId]
                    && this.$refs['querybuilder' + this.cId].ej2Instances
                    && typeof this.$refs['querybuilder' + this.cId].ej2Instances.getRules === 'function'
                ) {
                    result = this.$refs['querybuilder' + this.cId].ej2Instances.getValidRules();
                    if (this.otherProps.convertLogic) {
                        let psp = this.psp;
                        if (!psp && Array.isArray(result?.rules) && result.rules.length) {
                            psp = result.rules[0].psp; // Get psp from first logic condition
                        }
                        result = library.parseLogicToBackend(result, psp);
                        if (!library.objIsEmpty(result)) {
                            result = JSON.stringify(result);
                        } else {
                            result = {};
                        }
                    }
                }
                return result;
            }
            for (let i in this.logic) {
                if (i === 'length') continue;
                let builderInstance = this.$refs
                    && this.$refs['querybuilder' + i]
                    && this.$refs['querybuilder' + i].length
                    && this.$refs['querybuilder' + i][0].ej2Instances;
                let tmp = library.cloneObj(this.logic[i]);
                if (!this.logic[i].customRule && builderInstance) {
                    builderInstance.getRuleCollection = locals.getRuleCollection;
                    let validRules = builderInstance.getValidRules(builderInstance.rule);
                    tmp.criteria = validRules;
                }
                result.push(tmp);
            }
            this.queryPreview = result;
            return result;
        },
    },
    components: {
        "ejs-querybuilder": defineAsyncComponent(() => import('@common/syncfusion/queryBuilder')),
        "e-columns": ColumnsDirective,
        "e-column": ColumnDirective,
        'ejs-button': defineAsyncComponent(() => import('@common/syncfusion/button')),
        'ejs-dropdownbutton': defineAsyncComponent(() => import('@common/syncfusion/dropdownButton'))
    }
};

componentStore.initComponent(logicEditorCmp, logicEditorConfig, '@common/logicEditor.vue');
export { logicEditorConfig, logicEditorCmp };
export default logicEditorCmp;
</script>

<style lang="scss">
$accent: #1976d2;
@import "@syncfusion/ej2-buttons/styles/material.scss";
@import "@syncfusion/ej2-popups/styles/material.scss";
@import "@syncfusion/ej2-splitbuttons/styles/material.scss";
@import "@syncfusion/ej2-dropdowns/styles/material.scss";
@import "@syncfusion/ej2-inputs/styles/material.scss";
@import "@syncfusion/ej2-lists/styles/material.scss";
@import "@syncfusion/ej2-calendars/styles/material.scss";
@import "@syncfusion/ej2-querybuilder/styles/material.scss";
@import "@syncfusion/ej2-navigations/styles/material.scss";

.e-query-builder {
    margin: 0 auto;
}

.e-rule-filter {
    width: 100% !important;
}

.sub-setting-logic {
    width: 100%;
}

.sub-setting-logic label {
    margin-bottom: 10px;
    display: block;
}

.sub-setting-logic .sub-setting-logic-items {
    margin: 0;
    padding: 0;
    list-style: none;
}

.sub-setting-logic .sub-setting-logic-items li + li {
    border-top: 2px solid #8894e1;
}

.sub-setting-logic .sub-setting-logic-items .sub-setting-logic-items li {
    width: 100%;
}
.sub-setting-logic .object-item-toggle {
    flex-grow: 9;
    color: #fff;
    background: #566bf0;
    padding: 8px 12px;
    text-align: left;
    border: 0 none;
}
.sub-setting-logic .object-item-content {
    padding: 5px 8px 8px 8px;
    margin-bottom: 8px;
    border: 1px solid #566bf0;
}
.sub-setting-logic .e-expand:before {
    content: '\e653' !important;
}
.sub-setting-logic .e-collapse:before {
    content: '\e652' !important;
}
.sub-setting-logic .e-menu:before {
    content:'\e984' !important;
}
.sub-setting-logic .expander-toggle {
    margin-right: 5px;
}
.sub-setting-logic .expander-toggle .e-collapse {
    position: relative;
    top: 8px;
    left: -2px;
}
.sub-setting-logic .expander-toggle .e-expand {
    position: relative;
    top: 2px;
}
.sub-setting-logic .editor-item-action {
    padding: 2px;
    border: 1px solid #ccc;
}
.sub-setting-logic {
    border: 1px solid rgba(0, 0, 0, 0.24);
    border-radius: 4px;
}
.sub-setting-logic .action-area {
    margin: 0;
    padding: 6px;
    min-height: 40px;
}
.sub-setting-logic-items .action-area {
    display: flex;
    padding: 0;
}
.sub-setting-logic .action-area .add-item-btn {
    position: relative;
    float: right;
}
.sub-setting-logic .action-area .item-summary-label {
    background: #cce994;
    padding: 4px 8px;
    display: inline-block;
    border-radius: 3px;
}
.sub-setting-logic .sub-setting-logic-items li.logic-editor-action-area {
    border-top: 0 none;
}
.logic-editor-action-area {
    margin: 10px 0 5px 0;
    display: flex;
    flex-direction: row;
}
.available-paths {
    max-height: 300px;
    overflow: auto;
}
.sub-setting-logic .sub-setting-logic-items .available-paths {
    padding: 10px;
    background: #f0f0f0;
}
.sub-setting-logic .sub-setting-logic-items .show-hide-paths-button {
    text-align: center;
}
.query-preview {
    background: #ccc;
    padding: 10px;
    width: 380px;
}
.query-preview pre {
    white-space: pre-wrap;
}
.path-fields {
    position: relative;
    z-index: 3;
    padding: 10px;
    background: white;
    border-radius: 4px;
    border: 1px solid #ccc;
}
.path-fields p {
    margin-bottom: 20px;
}
.guide-title {
    font-size: 22px;
    margin-bottom: 20px;
}
.logic-settings-button-area {
    display: flex;
    flex-direction: row;
    gap: 3px;
    flex: 1 1 0;
}
.logic-settings-button-area button{
    display: block;
    padding: 5px;
    background: #f0f0f0;
    border: 1px solid #aaa;
    font-size: 16px;
    text-align: center;
    border-radius: 4px;
    margin-bottom: 6px;
    flex: 1 1 0;
}
.logic-settings-button-area button.help-button {
    text-decoration: underline;
    padding: 0 10px 10px 10px;
    border: 0 none;
    background: transparent;
    display: block;
    color: #1829d4;
    flex: 0;
}
.logic-settings-button-area button.active-button{
    background: #cce994;
    text-decoration: underline
}
.fl {
    float: left;
    padding: 0px 0px 12px 12px;
}
.e-rule-operator, .e-rule-sub-operator {
    float: left;
}

.fields-not-found-warning {
    color: #eb5202;
    font-weight: bold;
}
</style>
